<template>
  <div>
    <v-container fluid class="px-15 pb-10 pt-4">
      <v-row v-if="!loading" justify="start" align="start" class="ma-0 mt-5 mb-10">
        <v-col cols="6" class="pa-0">
          <div class="headline-medium text-primary">
            {{ texts.dashboard.welcomeTitle }} {{ items.sUserName }}!
          </div>
          <div class="body-large text-secondary">
            {{ texts.dashboard.dashboardDescription }}
          </div>
        </v-col>
        <!-- <v-col cols="6" class="pa-0" style="display: flex; justify-content: flex-end; align-items: center;">
          <v-btn
            color="rgb(25, 61, 110)"
            text
            rounded
            @click="openToursDialog()"
            style="font-family: 'montserrat-bold'; text-transform: none; font-size: 16px;"
          >
            <v-icon left>mdi-bell-outline</v-icon>
            Actualizaciones
            <v-chip
              v-if="unreadToursCount > 0"
              small
              color="red"
              text-color="white"
              class="ml-2"
              style="font-family: 'montserrat-bold';"
            >
              {{ unreadToursCount }}
            </v-chip>
          </v-btn>
        </v-col> -->
      </v-row>
      <v-skeleton-loader
        v-else
        class="mx-3 my-3"
        width="348"
        height="100px"
        type="image"
      ></v-skeleton-loader>
      <!-- Cards -->
      <v-row>
        <v-col style="display: flex; justify-content: center;">
          <v-card
            v-if="!loading"
            class="card-main mx-4"
            style="border: 1px solid #c5cdd3; border-radius: 32px; background: rgb(97,163,217); background: linear-gradient(180deg, rgba(97,163,217,1) 0%, rgba(25,61,110,1) 100%);"
            width="348"
            elevation="5"
            height="200"
            outlined
          >
            <v-card-text class="pa-0 pt-3">
              <v-row align="center" class="pt-2 pl-2">
                <v-col cols="9" class="pl-5">
                  <div style="color: #FFFFFF; font-family: montserrat-bold; font-size: 16px;">{{ texts.dashboard.exchangeRateActual }}</div>
                  <div class="content-balance" style="color: #FFFFFF; font-family: montserrat-bold; font-size: 32px;">
                    ${{ items.exchangeRateToday ? (items.exchangeRateToday < 1 ? (1 / items.exchangeRateToday).toFixed(2) : (items.exchangeRateToday).toFixed(2)) : 0 }} MXN 
                    <!-- <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon style="margin-top: -2px; color: white;" small v-bind="attrs" v-on="on">mdi-information</v-icon>
                      </template>
                      <span>{{ "El tipo de cambio completo es: " + items.exchangeRateToday + " MXN" }}</span> 
                    </v-tooltip> -->
                  </div>
                </v-col>
              </v-row>
              <div
                class="pl-4 pt-2 blocked-amount"
                style="position: relative; z-index: 8; padding-right: 120px; color: #FFFFFF; font-family: montserrat-bold; font-size: 12px;"
              >
                {{ texts.dashboard.exchangeRateTodayDescription }} {{ countdownDashboard }}
                {{ texts.dashboard.seconds }}
              </div>
              <div class="pt-2 pl-4">
                <v-btn
                  @click="openModalAlerts(), stopDashboardRateTimer()"
                  color="white"
                  class="mt-2 d-flex align-center"
                  elevation="0" 
                  rounded
                >
                  <div style="display: flex; justify-content: center; align-items: center; background-color: #fff; color: #193D6E;  
                              margin-right: 8px; box-shadow: 4px 0 4px rgba(0, 0, 0, 0.2); padding: 8px; border-radius: 50%; margin-left: -16px;">
                    <v-icon color="#193D6E" size="20">mdi-bell</v-icon>
                  </div>
                  <span style="color: black; text-align: left; text-transform: none; font-family: montserrat-semibold; font-size: 12px">
                    {{ texts.dashboard.createAlerts }}
                  </span>
                </v-btn>
              </div>
            </v-card-text>
            <div
              style="
                position: absolute;
                top: 0;
                right: 0;
                margin-top: -12px;
                margin-right: -42px;
                background-color: #7ea4c9;
                -webkit-box-shadow: 0px 5px 8px 3px rgba(0,0,0,0.75);
                -moz-box-shadow: 0px 5px 8px 3px rgba(0,0,0,0.75);
                box-shadow: 0px 5px 8px 3px rgba(0,0,0,0.75);
                width: 150px;
                height: 150px;
                border-radius: 100px;
              "
            ></div>
          </v-card>
          <v-skeleton-loader
            v-else
            class="mx-3 my-3"
            width="348"
            height="200"
            type="image"
          ></v-skeleton-loader>
        </v-col>
        <v-col style="display: flex; justify-content: center;">
          <v-card
            v-if="!loading"
            class="card-main mx-4"
            style="border: 1px solid #c5cdd3; border-radius: 32px;"
            width="348"
            elevation="5"
            height="200"
            outlined
          >
            <v-card-text class="pt-6">
              <v-row align="center">
                <v-col cols="9" class="pl-5">
                  <div class="usd-balance" style="font-family: montserrat-semibold;">{{ texts.dashboard.usdBalance }}</div>
                  <div class="content-balance" style="font-family: montserrat-semibold;">
                    ${{ formatMoney(balanceUsd ? balanceUsd : 0) }} USD
                  </div>
                </v-col>
                <v-col cols="3" class="text-right pr-5">
                  <v-img
                    style="border-radius: 10px;
                    -webkit-box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);
                    -moz-box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);
                    box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);"
                    src="../../assets/images/Flags_usa.svg"
                    alt="usa-flag"
                    width="47"
                    height="35"
                  />
                </v-col>
              </v-row>
              <div class="pl-3 pt-2 blocked-amount" style="font-family: montserrat-semibold;">
                {{ texts.dashboard.blockedAmount }}
                <span class="blocked-amount-2" style="font-family: montserrat-semibold;"
                  >${{ formatMoney(blockedUsd ? blockedUsd : 0) }}</span
                >
              </div>
              <div style="text-align: center">
                <v-btn
                  small
                  color="white"
                  class="btn-custom mt-2"
                  elevation="0"
                  @click="openModalAddFounds('USD'), stopDashboardRateTimer()"
                >
                  <v-icon left dark color="#0075B8"> - -plus-circle-outline</v-icon>
                  <span class="buttonAddFounds" style="font-family: montserrat-semibold;">{{ texts.dashboard.addFounds }}</span>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
          <v-skeleton-loader
            v-else
            class="mx-3 my-3"
            width="348"
            height="200"
            type="image"
          ></v-skeleton-loader>
        </v-col>
        <v-col style="display: flex; justify-content: center;">
          <v-card
            v-if="!loading"
            class="card-main mx-4"
            style="border: 1px solid #c5cdd3; border-radius: 32px;"
            width="348"
            height="200"
            elevation="5"
            outlined
          >
            <v-card-text class="pt-6">
              <v-row align="center">
                <v-col cols="9" class="pl-5">
                  <div class="usd-balance" style="font-family: montserrat-semibold;">{{ texts.dashboard.mxnBalance }}</div>
                  <div class="content-balance pt-3" style="font-family: montserrat-semibold;">
                    ${{ formatMoney(balanceMxn ? balanceMxn : 0) }} MXN
                  </div>
                </v-col>
                <v-col cols="3" class="text-right pr-5">
                  <v-img
                    style="border-radius: 10px;
                      -webkit-box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);
                      -moz-box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);
                      box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.75);"
                    src="../../assets/images/Flags_mex.svg"
                    alt="mex-flag"
                    width="47"
                    height="35"
                  />
                </v-col>
              </v-row>
              <div class="pl-3 pt-2 blocked-amount" style="font-family: montserrat-semibold;">
                {{ texts.dashboard.blockedAmount }}
                <span class="blocked-amount-2" style="font-family: montserrat-semibold;"
                  >${{ formatMoney(blockedMXN ? blockedMXN : 0) }}</span
                >
              </div>
              <div style="text-align: center">
                <v-btn
                  small
                  color="white"
                  class="btn-custom mt-2"
                  elevation="0"
                  @click="openModalAddFounds('MXN'), stopDashboardRateTimer()"
                >
                  <v-icon left dark color="#0075B8"> - -plus-circle-outline</v-icon>
                  <span class="buttonAddFounds" style="font-family: montserrat-semibold;">{{ texts.dashboard.addFounds }}</span>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
          <v-skeleton-loader
            v-else
            class="mx-3 my-3"
            width="348"
            height="200"
            type="image"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <!-- buttons  -->
      <v-row class="mt-10 mx-auto mb-10" style="justify-content: space-around">
        <v-btn
          v-if="!loading"
          color="#0075B8"
          :disabled="!company"
          class="btn-custom my-4 mx-4 py-5"
          elevation="2"
          style="width: 204px; border-radius: 36px;"
          outlined
          @click="e1 = 1, dialogWithdrawal = true, selectedCurrency = null, stopDashboardRateTimer()"
        >
          <v-icon left dark color="#0075B8">mdi-arrow-top-right-thin</v-icon>
          <span class="buttonAddFounds" style="font-family: 'montserrat-semibold';">{{ texts.dashboard.collectionPay }}</span>
        </v-btn>
        <v-btn
          v-if="!loading"
          color="#0075B8"
          class="btn-custom my-4 mx-4 py-5"
          elevation="2"
          style="width: 204px; border-radius: 36px;"
          outlined
          @click="e1 = 1, dialogSendPay = true, getSuppliers(),  stopDashboardRateTimer()"
        >
          <v-icon left dark color="#0075B8">mdi-arrow-top-right-thin</v-icon>
          <span class="buttonAddFounds" style="font-family: 'montserrat-semibold';">{{ texts.dashboard.sendPay }}</span>
        </v-btn>
        <!-- <v-btn
          v-if="!loading"
          color="#0075B8"
          class="btn-custom my-4 mx-4 py-5"
          elevation="2"
          style="width: 204px; border-radius: 36px;"
          outlined
          @click="e1 = 1, dialogSendPayMassive = true, getSuppliers(),  stopDashboardRateTimer()"
        >
          <v-icon left dark color="#0075B8">mdi-arrow-top-right-thin</v-icon>
          <span class="buttonAddFounds" style="font-family: 'montserrat-semibold';">{{ texts.dashboard.sendPayMassive }}</span>
        </v-btn> -->
        <v-btn
          v-if="!loading"
          color="#0075B8"
          class="btn-custom my-4 mx-4 py-5"
          elevation="2"
          style="width: 204px; border-radius: 36px;"
          outlined
          @click="dialogConvert = true, e1 = 1, selectedCard = null, stopDashboardRateTimer()"
        >
          <v-icon left dark color="#0075B8">mdi-swap-horizontal</v-icon>
          <span class="buttonAddFounds" style="font-family: 'montserrat-semibold';">{{ texts.dashboard.convert }}</span>
        </v-btn>
      </v-row>
      <!-- Fresher Coins -->
      <div class="mb-10 mt-5" v-if="!loading">
        <v-card class="pa-4 px-8" elevation="8" style="border-radius: 36px;">
          <div class="d-flex" style="justify-content: space-between">
            <div>
              <div class="d-flex">
                <div
                  style="
                    font-size: 32px;
                    font-weight: bold;
                    font-family: montserrat-semibold;
                    color: #193d6e;
                  "
                >
                  {{ items.fresherCoins }}
                </div>
                <div class="d-flex" style="align-items: center;">
                  <v-img class="mr-2" src="../../assets/icons/fresherCoin.svg" style="width: 24px; height: 24px; margin-left: 5px;"></v-img>
                </div>
              </div>
              <div class="text-primary" style="font-size: 18px; font-family: montserrat-regular; color: #2D2D2D;">
                {{ "Fresher coins" }}
              </div>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 20px; margin-left: 25px;">
              <v-btn
                :disabled="false"
                @click="dialogRewards = true, stopDashboardRateTimer()"
                class="px-6"
                elevation="0"
                style="border-radius: 20px; background-color: #F6F6F7; color: #0075B8; font-family: montserrat-semibold; font-size: 14px; text-transform: none;"
              >
                <v-img class="mr-2" src="../../assets/icons/gift.svg" style="width: 14px;"></v-img>
                {{ selectLanguage === "sp" ? "Recompensas" : "Rewards" }} 
              </v-btn>
            </div>
          </div>
          <div style="display: flex; align-items: flex-end; justify-content: space-between;">
            <div class="scroll" style='overflow-x: scroll; position: relative; height: 100px; display: flex;'>
              <div class="d-flex">
                <div
                  v-for="idx in 20"
                  :key="idx"
                  class="d-flex"
                  style="flex-direction: column; justify-content: flex-end;"
                >
                  <div style="margin-bottom: 5px; position: absolute; margin-top: -77px;">
                    <div v-if="shouldShowItem(idx)" class="custom-text" :style="{ marginLeft: computedMarginLeft() }">
                      <v-img class="mr-2" src="../../assets/icons/marker.svg" style="width: 36px;"></v-img>
                    </div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on"   style="color: #193d6e; position: absolute; margin-top: -77px; z-index: 1;" v-if="Math.floor(items.pendingFresherCoins / 2500) == idx - 1" :style="{ marginLeft: pendingFresherCoins() }">
                          <v-img class="mr-2" src="../../assets/icons/markerGrey.svg" style="width: 36px;"></v-img>
                        </div>
                      </template>
                      <span>{{ selectLanguage == 'en' ? 'Pending forwards to process' : 'Forwards pendientes por procesar' }}</span>
                    </v-tooltip>
                  </div>
                  <div class="d-flex" style="flex-direction: row">
                    <div style="display: flex; flex-direction: column; margin-left: -5px; align-items: center; width: 40px;">
                      <div
                        :style="Math.floor(items.fresherCoins / 2500) < idx - 1 ? 'border-radius: 100px; border: 4px solid; width: 20px; background-color: white; height: 20px; color: rgba(0, 0, 0, 0.25)' : 'border-radius: 100px; border: 7px solid; width: 20px; background-color: white; height: 20px; z-index: 8; color: #193d6e;'"
                      ></div>
                      <div style="color: black; font-family: 'montserrat-medium'; font-size: 16px;">
                        {{ (idx - 1) * 2500 }}
                      </div>
                    </div>
                    <div
                      v-if="idx < 20"
                      :style="Math.floor(items.fresherCoins / 2500) > idx - 1 ? 
                        'width: 80px; margin-top: 7.5px; height: 5px; background-color: #193d6e; border-radius: 5px; margin-left: -15px; margin-right: -15px' : 
                        Math.floor(items.fresherCoins / 2500) == idx - 1 ? 
                        `width: 80px; margin-top: 7.5px; height: 5px; background: linear-gradient(to right, #193d6e ${(((items.fresherCoins % 2500) / 2500) * 100) - 10 }%, rgba(0, 0, 0, 0.25) ${((((items.fresherCoins % 2500) / 2500) * 100) - 10) + 30 }%); border-radius: 5px; margin-left: -15px; margin-right: -15px` : 
                        'width: 80px; margin-top: 7.5px; height: 5px; background-color: rgba(0, 0, 0, 0.25); border-radius: 5px;margin-left: -15px; margin-right: -15px'"
                    />
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </v-card>
      </div>
      <v-skeleton-loader
        v-else
        class="mx-3 my-3"
        width="100%"
        height="100px"
        type="image"
      ></v-skeleton-loader>
    </v-container>

    <v-dialog v-if="dialogAlerts" v-model="dialogAlerts" persistent class="pa-8" max-width="720">
      <v-card style="background-color: #F9FAFD">
          <div>
            <v-card-title class="d-flex justify-space-between align-center" style="color: #193D6E; font-weight: bold;">
              <span style="font-size: 24px;">{{ texts.dashboard.priceAlerts }}</span>
              <v-btn icon @click="dialogAlerts = false, isLoadingAlerts = false, alerts = [], getDashboard('alerts')">
                <v-icon color="#193D6E">mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text class="px-16" style="background-color: #F9FAFD">
              <v-container
                class="pa-10 py-7"
                style="background-color: #FFF; border-radius: 10px; padding: 20px; margin-bottom: 16px;"
              >
                <v-row align="center" justify="space-between">
                  <v-col class="d-flex flex-column">
                    <div class="pb-5" style="color: #193D6E; font-size: 20px; font-weight: 550;">
                      1 USD =
                    </div>
                    <div class="pb-2" style="color: #193D6E; font-weight: bold; font-size: 36px;">
                      {{ items.exchangeRateToday ? items.exchangeRateToday.toFixed(2) : 0 }} MXN
                    </div>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn color="#0075B8" rounded class="d-flex align-center" @click="openDialogAlertsCreate" style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);">
                      <v-icon left color="white">mdi-bell</v-icon>
                      <span style="color: white; text-transform: none;">{{ texts.dashboard.createAlert }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>

              <v-container style="background-color: #FFF; border-radius: 30px; border: 1px solid #D4D4D4; min-height: 200px;" class="mb-5">
                <v-data-table
                  :headers="headersAlerts"
                  :items="alerts"
                  hide-default-footer
                >
                  <template v-slot:top>
                  </template>
                  <template v-slot:item.dAmount="{ item }">
                    <div style="display: inline-flex; align-items: center;">
                      <v-img
                        src="../../assets/icons/usa-mex.png"
                        alt="usd-mxn"
                        style="width: 26px; height: 16px; margin-right: 20px; object-fit: contain;"
                      ></v-img>
                      <span style="color: #2D2D2D; font-weight: 400;">1 USD = {{ item.dAmount }} MXN</span>
                    </div>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon v-if="!isLoadingAlertsDelete" size="20" color="#F44336" @click="deleteAlert(item)">mdi-trash-can</v-icon>
                    <v-progress-circular v-else indeterminate color="#F44336" size="20"></v-progress-circular>
                  </template>
                </v-data-table>
              </v-container>
            </v-card-text>
          </div>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogAlertsCreate" v-model="dialogAlertsCreate" persistent class="pa-8" max-width="450">
      <v-card>
        <v-card-title class="pl-16" style="color: #193D6E; font-weight: bold">
          <span style="font-size: 24px;">{{ texts.dashboard.createAlert }}</span>
        </v-card-title>
        <v-card-subtitle class="pl-16 pt-2">
          <v-icon color="#12A150">mdi-trending-up</v-icon> <span style="color: #12A150;">1 USD = {{ items.exchangeRateToday ? items.exchangeRateToday.toFixed(2) : 0 }} MXN</span>
        </v-card-subtitle>
        <v-card-text>
         <v-container class="d-flex justify-center" style="color: #193D6E; font-size: 16px; font-weight: 500;">
          {{ texts.dashboard.notifyMeToSellUSD }}
         </v-container>

         <v-container class="d-flex justify-center px-12">
          <v-text-field
            type="number"
            v-model="targetPrice"
            solo
            :suffix="texts.dashboard.targetPrice"
            class="mb-5"
            style="border-radius: 10px; color: #737583;"
            hide-spin-buttons
            :autofocus="false"
          >
            <template #prepend-inner>
              <img src="../../assets/images/mx-flag.png" alt="Custom Icon" style="width: 26px; height: 20px;" />
            </template>
          </v-text-field>
         </v-container>

         <v-container class="d-flex justify-center">
          <v-row class="d-flex justify-center">
            <v-col class="d-flex justify-center">
              <v-btn color="#FFFFFF" rounded class="d-flex align-center" @click="dialogAlertsCreate = false, targetPrice = null, isLoadingAlertsCreate = false" style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border: 1px solid #0075B8; width: 150px;">
                <span style="color: #0075B8; text-transform: none; font-size: 16px;">{{ texts.dashboard.alertCancel }}</span>
              </v-btn>
            </v-col>
            <v-col class="d-flex justify-center">
              <v-btn
              color="#0075B8"
              rounded
              class="d-flex align-center"
              @click="createAlert"
              :loading="isLoadingAlertsCreate"
              style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); width: 150px;"
            >
              <template v-slot:loader>
                <v-progress-circular
                  indeterminate
                  :size="20"
                  style="color: white;"
                ></v-progress-circular>
              </template>
              <span style="color: white; text-transform: none; font-size: 16px;">{{ texts.dashboard.alertCreate }}</span>
            </v-btn>
            </v-col>
          </v-row>
         </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogAddFounds" v-model="dialogAddFounds" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="title font-weight-bold text-textblack">
            {{ texts.dashboard.addFounds }}
          </span>
          <v-btn icon @click="dialogAddFounds = false, getDashboard('addFounds')">
            <v-icon color="#2E404E">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="py-6">
          <v-sheet rounded="lg" color="#F7F8F9" class="pa-13">
            <div v-if="addFoundsCurrency == 'USD'" style="display: flex; gap: 20px;">
              <v-card style="border-radius: 20px;" v-if="!isLoadingFounds">
                <v-card-text>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Beneficiary" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.beneficiary }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Beneficiary Address" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.beneficiary_address }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Bank Name" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.bank_name }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Bank Address" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.bank_address }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between" v-if="dataAddFounds">
                    <div style="font-family: 'montserrat-bold';">{{ "Account Type" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.account_type }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Account Number" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.account_number }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between" v-if="dataAddFounds">
                    <div style="font-family: 'montserrat-bold';">{{ "Routing Code WIRE" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.routing_code[1] }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between" v-if="dataAddFounds">
                    <div style="font-family: 'montserrat-bold';">{{ "Routing Code ACH" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.routing_code[0] }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Swift Code" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.swift_code }}</div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-if="addFoundsCurrency == 'MXN'">
              <v-card style="border-radius: 20px;" width="400px">
                <v-card-text>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Beneficiary" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.beneficiary }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "Bank Name" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.bank_name }}</div>
                  </div>
                  <div class="d-flex mb-2" style="justify-content: space-between">
                    <div style="font-family: 'montserrat-bold';">{{ "CLABE" }}</div>
                    <div style="font-family: 'montserrat-bold'; text-align: right; text-wrap: wrap; max-width: 180px;"> {{ dataAddFounds.account_number }}</div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogWithdrawal" v-model="dialogWithdrawal"  persistent class="pa-8" width="fit-content">
      <v-stepper v-model="e1" alt-labels elevation="0">
        <v-stepper-header v-if="e1 < 4" color="#193D6E" class="mt-5 mr-15 ml-15" elevation="0" 
          style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
        >
          <v-stepper-step :complete="e1 > 1" step="1" color="#193D6E"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2" color="#193D6E"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3" color="#193D6E"></v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" elevation="0" class="pt-0" style="">
            <v-container class="mt-1" width="920">
              <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                <span class="title font-weight-bold text-textblack">
                  {{ texts.invoices.selectTypeOfWalletPay }}
                </span>
              </v-card-title>
              <v-card-text class="py-6 px-4" v-if="!loading" style="display: flex; align-items: center; width: fit-content; margin: auto; gap: 30px; flex-wrap: wrap; justify-content: center;">
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'USD'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                        <div class="usd-balance">{{ "Wallet USD" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'USD'" color="#193D6E">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceUsd ? balanceUsd : 0) }} USD
                    </div>
                  </div>
                </v-card>
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'MXN'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                        <div class="usd-balance">{{ "Wallet MXN" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'MXN'" color="#193D6E">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceMxn ? balanceMxn : 0) }} MXN
                    </div>
                  </div>
                </v-card>
              </v-card-text>
              <div v-else style="display: flex; justify-content: center">
                <v-progress-circular indeterminate color="amber"></v-progress-circular>
              </div>
              <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                <v-btn
                  elevation="4"
                  class="mr-2 px-10"
                  style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  @click="selectedCurrency = null, dialogWithdrawal = false, getDashboard('withdrawal')"
                >
                  {{ texts.modalForm.cancel }}
                </v-btn>
                <v-btn
                  color="#0075B8"
                  elevation="4343"
                  class="white--text px-10"
                  style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                  :loading="loading"
                  :disabled="selectedCurrency === null"
                  @click="e1 = 2, selectedCurrency != (company?.sAccountCurrency) ?  getRate(selectedCurrency, company?.sAccountCurrency) : null"
                >
                  {{ texts.modalForm.continue }}
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-stepper-content>
          <v-stepper-content step="2" class="pt-0">
            <v-container class="d-flex justify-center">
              <v-card width="650" style="box-shadow: none !important;">
                <v-card-title class="pt-0" style="display: flex; justify-content: center; font-family: 'montserrat-bold'; font-size: 28px; color: #2E404E;">
                  {{ texts.dashboard.transferMoney }}
                </v-card-title>
                <v-card-text class="info-card">
                  <!-- Saldo en cuenta -->
                  <div class="text-center mb-12">
                    <v-card class="pa-3 mt-2" outlined style="display: flex; justify-content: space-between; background-color: #F2F2F2; border-radius: 10px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);">
                      <div style="text-align: start;">
                        <div style="font-family: 'montserrat-bold'; font-size: 18px; color: black;">
                          {{ "Cliente:" }}
                        </div>
                        <div v-if="company" style="font-family: 'montserrat-bold'; font-size: 18px; color: #737583;">
                          {{ company?.sName + " - *" + (company?.accountNumber ? (company?.accountNumber).slice(-4) : (company?.sAccountNumber).slice(-4)) }}
                        </div>
                      </div>
                      <div style="text-align: end;">
                        <div style="font-family: 'montserrat-bold'; font-size: 18px; color: black;">
                          {{ "Saldo de la cuenta:" }}
                        </div>
                        <div v-if="company?.sAccountNumber" style="font-family: 'montserrat-bold'; font-size: 18px; color: #737583;">
                          ${{ formatMoney(selectedCurrency == 'USD' ? balanceUsd : balanceMxn) }} {{ selectedCurrency == 'USD' ? 'USD' : 'MXN' }}
                        </div>
                      </div>
                    </v-card>
                  </div>

                  <!-- Sección de entrada de monto -->
                  <div class="my-6">
                    <v-text-field
                      outlined
                      :label="`De ${currencyMap[selectedCurrency]?.name}`"
                      type="number"
                      dense
                      :disabled="selectedCurrency != (company?.sAccountCurrency) ? isLoadingRate : false"
                      hide-details
                      v-model="amounts[selectedCurrency]"
                      @change="selectedCurrency != (company?.sAccountCurrency) ? calculatorAmount(amounts[selectedCurrency], selectedCurrency == 'USD' ? false : true, selectedCurrency, company?.sAccountCurrency) : null"
                      prefix="$"
                      class="mb-7"
                    >
                      <template v-slot:append>
                        <div class="d-flex align-center">
                          <img
                            :src="currencyMap[selectedCurrency]?.flag"
                            width="24"
                            height="24"
                            alt=""
                            class="rounded"
                          />
                          <h4 class="ml-2 font-weight-bold">{{ selectedCurrency }}</h4>
                        </div>
                      </template>
                    </v-text-field>
                    <v-text-field
                      outlined
                      :label="`A ${currencyMap[company?.sAccountCurrency]?.name}`"
                      type="number"
                      dense
                      hide-details
                      :disabled="isLoadingRate"
                      v-if="selectedCurrency != (company?.sAccountCurrency)"
                      v-model="amounts[company?.sAccountCurrency]"
                      @change="calculatorAmount(amounts[company?.sAccountCurrency], true, selectedCurrency, company?.sAccountCurrency)"
                      prefix="$"
                      class="mb-5"
                    >
                      <template v-slot:append>
                        <div class="d-flex align-center">
                          <img
                            :src="currencyMap[company.sAccountCurrency]?.flag"
                            width="24"
                            height="24"
                            alt=""
                            class="rounded"
                          />
                          <h4 class="ml-2 font-weight-bold">{{ company.sAccountCurrency }}</h4>
                        </div>
                      </template>
                    </v-text-field>
                  </div>
                  <div v-if="selectedCurrency === (company?.sAccountCurrency) && selectedCurrency == 'USD'" class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                    <div class="mr-4" style="border-right: #0075B8 solid 4px; height: 35px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E;">
                          Al realizar un retiro de USD a USD se aplicará un fee de $12.50 USD.
                        </div>
                      </div>
                    </div>
                  <div v-if="selectedCurrency != (company?.sAccountCurrency)">
                    <v-row class="align-center">
                      <v-col class="pb-0">
                        <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                          {{ texts.dashboard.exchangeRate }}
                        </div>
                      </v-col>
                      <v-col class="pb-0 d-flex justify-end">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mr-1" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ "El cálculo se realizó con " + exchangeRateToday + " MXN" }}</span> 
                        </v-tooltip>
                        <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                          1 {{ baseCurrency }} = <span v-if="!isLoadingRate">${{ exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2) }}</span> <v-progress-circular v-else size="22" indeterminate class="ma-2" color="primary"></v-progress-circular> {{ company?.sAccountCurrency }}
                        </h2>
                      </v-col>
                    </v-row>

                    <!-- Temporizador de actualización -->
                    <v-row class="align-center mt-5">
                      <v-col class="pb-0">
                        <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                          {{ texts.dashboard.exchangeRateTodayDescription }}
                        </div>
                      </v-col>
                      <v-col class="pb-0 d-flex justify-end">
                        <h2 :class="{ 'text-red': countdownRate < 30, 'text-black': countdownRate >= 30 }" style="text-wrap: nowrap; font-size: 18px;">
                          {{ countdownRate }} {{ texts.dashboard.seconds }}
                        </h2>
                      </v-col>
                    </v-row>
                  </div>
                  
                  <!-- Total convertido -->
                  <v-row class="align-center mt-5">
                    <v-col class="pb-0" :style="{ 'margin-bottom': selectedCurrency != (company?.sAccountCurrency) ? '0' : '25px' }">
                      <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                        {{ "Total origin" }}
                      </div>
                    </v-col>
                    <v-col class="pb-0 d-flex justify-end">
                      <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                        ${{ amounts[selectedCurrency] ? formatMoney(amounts[selectedCurrency]) : 0 }} {{ selectedCurrency }}
                      </h2>
                    </v-col>
                  </v-row>
                  <!-- Total convertido -->
                  <v-row v-if="selectedCurrency != (company?.sAccountCurrency)" class="align-center mt-5 mb-4">
                    <v-col class="pb-0">
                      <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                        {{ texts.dashboard.totalConverted }}
                      </div>
                    </v-col>
                    <v-col class="pb-0 d-flex justify-end">
                      <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                        ${{ amounts[company?.sAccountCurrency] ? formatMoney(amounts[company?.sAccountCurrency]) : 0 }} {{ company?.sAccountCurrency }}
                      </h2>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 1, amounts = { MXN: null, USD: null }, exchangeRateToday = null, exchangeRateTodayReference = null, stopRateTimer()"
                  >
                    {{ texts.modalForm.return }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="!amounts[company?.sAccountCurrency] || (selectedCurrency != (company?.sAccountCurrency) ? isLoadingRate : false) || amounts[company?.sAccountCurrency] == 0 || amounts[selectedCurrency] == 0 || parseFloat(amounts[selectedCurrency]) > (selectedCurrency == 'USD' ? balanceUsd : balanceMxn)"
                    @click="e1 = 3, stopRateTimer(), comment = ''"
                  > 
                    {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-container>
          </v-stepper-content>
          <v-stepper-content step="3" class="pt-0">
            <v-container class="d-flex justify-center">
              <v-card width="800" style="box-shadow: none !important;">
                <v-card-title class="pt-0" style="display: flex; justify-content: center; font-family: 'montserrat-bold'; font-size: 24px; color: #2E404E;">
                  {{ "Detalle del retiro" }}
                </v-card-title>
                <v-card-text class="info-card" style="box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);">
                  <div class="info-block">
                    <div style="display: flex; justify-content: space-between;">
                      <p class="label">Cliente:</p>
                      <p class="value">{{ company?.sName }}</p>
                    </div>
                    <div style="display: flex; justify-content: space-between;" v-if="company">
                      <p class="label">Número de cuenta:</p>
                      <p class="value">{{ "*" + (company?.accountNumber ? (company?.accountNumber).slice(-4) : (company?.sAccountNumber).slice(-4)) }}</p>
                    </div>
                    <div v-if="selectedTypeOfPayment == 'Spot'" style="display: flex; justify-content: space-between; align-items: center;">
                      <p class="label">Fecha de pago:</p>
                      <p class="value">{{ paymentDay }}</p>
                    </div>
                    <div v-if="selectedTypeOfPayment == 'Window Spot'" style="display: flex; justify-content: space-between;">
                      <p class="label">Fecha limite:</p>
                      <p class="value">{{ limitWindowSpot }}</p>
                    </div>
                  </div>
                  <div v-if="selectedTypeOfPayment == 'Window Spot'" class="mb-4 py-3" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                    <!-- Barra lateral azul -->
                    <div class="mr-4" style="border-right: #0075B8 solid 4px; height: 90px"></div>
                    <!-- Contenido de texto -->
                    <div style="display: flex; flex-direction: column;">
                      <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
                        Al programar un Window Spot tienes que cumplir con las siguientes condiciones:
                      </div>
                      <ul style="padding-left: 16px; margin: 0; font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                        <li>Depositar el 100% del monto origen dentro de un plazo de 7 {{ selectedCurrency == 'MXN' ? '3 horas' : '7 días' }}. Este monto será descontado de tu balance al ingresarlo y convertido al monto destino.</li>
                      </ul>
                    </div>
                  </div>
                  <div class="info-block mb-0">
                    <div style="display: flex; justify-content: space-between;" v-if="selectedCurrency != (company.sAccountCurrency)">
                      <p class="label">Tipo de cambio:</p> 
                      <p class="value">{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                      <p class="label">Monto origen:</p>
                      <p class="value">{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                    </div>
                    <div class="mb-0" style="display: flex; justify-content: space-between;" v-if="selectedCurrency != (company.sAccountCurrency)">
                      <p class="label">Monto destino:</p>
                      <p class="value">{{ "$ " + formatMoney(amounts[company.sAccountCurrency]) + " " + (company.sAccountCurrency) }}</p>
                    </div>
                  </div>
                  <div class="info-block mt-3">
                    <v-textarea
                      class="pa-4"
                      rows="2"
                      :label="texts.dashboard.paymentConcept"
                      v-model="comment"
                      no-resize
                      hide-details
                    ></v-textarea>
                  </div>
                  <div v-if="selectedCurrency != (company.sAccountCurrency)">
                    <v-card class="d-flex pa-2 mt-4 mb-3" @click="selectedTypeOfPayment = 'Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between;">
                      <div>
                        <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Retiro instantaneo" }}</div>
                        <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                          {{ "Al utilizar retiro instantaneo se descontara de tu balance origen y se enviara a tu cuenta de banco." }}
                        </div>
                      </div>
                      <v-icon v-if="selectedTypeOfPayment === 'Spot'" color="#193D6E">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                    <v-card class="d-flex pa-2" @click="selectedTypeOfPayment = 'Window Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between;">
                      <div>
                        <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Retiro diferido" }}</div>
                        <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                          {{ "Al utilizar retiro diferido se creara un window spot y te permitira depositar el monto origen y una vez se refleje se enviara a tu cuenta de banco." }}
                        </div>
                      </div>
                      <v-icon v-if="selectedTypeOfPayment === 'Window Spot'" color="#193D6E">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </div>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 2, getRate(selectedCurrency, company.sAccountCurrency), amounts = { MXN: null, USD: null }, selectedTypeOfPayment = null"
                  >
                    {{ texts.modalForm.return }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="!comment || isLoading || ((selectedCurrency != (company.sAccountCurrency)) ? !selectedTypeOfPayment : false)"
                    @click="e1 = 4, otp = '', sendVerification()"
                  > 
                    {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-container>
          </v-stepper-content>
          <v-stepper-content step="4" class="pt-0">
            <v-container class="mt-1" style="max-width: 600px;">
              <v-card-title
                  class="pa-0"
                  style="display: flex; text-align: center; justify-content: center"
                >
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.twoFactor.twoFactor }}
                  </span>
              </v-card-title>
              <v-card-text class="py-6 pb-0" v-if="supplier">
                <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row;">
                  <div>
                    <v-otp-input
                      v-model="otp"
                      length="6"
                      type="number"
                      color="#193D6E"
                    ></v-otp-input>
                    <p style="font-size: 14px; font-weight: 500">
                      {{ texts.twoFactor.enterCode }}
                    </p>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                <v-btn
                  elevation="4"
                  class="mr-2 px-10"
                  style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  :disabled="loading"
                  @click="e1 = 3"
                >
                  {{ texts.modalForm.return }}
                </v-btn>
                <v-btn
                  color="#0075B8"
                  elevation="4343"
                  class="white--text px-10"
                  style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                  :loading="loading"
                  :disabled="otp.length < 6"
                  @click="e1 = 5, sendWithdrawal()"
                > 
                  {{ texts.modalForm.confirmCollect }}
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-stepper-content>
          <v-stepper-content step="5" class="pt-0">
            <v-container class="d-flex justify-center">
              <v-btn icon :disabled="loadingWithdrawal" @click="dialogWithdrawal = false, amounts = { MXN: null, USD: null }, exchangeRateToday = null, exchangeRateTodayReference = null, selectedCurrency = null, e1 = 1, selectedTypeOfPayment = null, comment = null, getDashboard('withdrawal')" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-card class="pa-6 mx-auto" style="box-shadow: none !important;">
                <div v-if="loadingWithdrawal" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando retiro...</p>
                </div>
                <div v-if="withdrawalError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ selectedTypeOfPayment === 'Window Spot' ? "Retiro programado correctamente!" :  "Retiro procesado correctamente!"}}
                  </v-card-title>
                </div>
                <div v-if="withdrawalError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el retiro!
                  </v-card-title>
                </div>

                <v-card-text class="pb-0 px-0">
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Payment concept:</p>
                        <v-skeleton-loader v-if="loadingWithdrawal" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingWithdrawal" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ company?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="!company">
                        <p class="label">Número de cuenta:</p>
                        <v-skeleton-loader v-if="loadingWithdrawal" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "*" + (company?.accountNumber ? (company?.accountNumber).slice(-4) : (company?.sAccountNumber).slice(-4)) }}</p>
                      </div>
                      <div v-if="selectedCurrency != (company.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingWithdrawal" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de pago:</p>
                        <v-skeleton-loader v-if="loadingWithdrawal" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingWithdrawal" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (company.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingWithdrawal" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + exchangeRateToday?.toFixed(2) + " MXN"  }}</p>
                      </div>
                      <div v-if="selectedCurrency != (company.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingWithdrawal" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingWithdrawal" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[company.sAccountCurrency]) + " " + (company.sAccountCurrency) }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-container>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>

    <v-dialog v-if="dialogSendPay" v-model="dialogSendPay" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header v-if="e1 < 4" color="#193D6E" class="mt-5 mr-15 ml-15" elevation="0" 
            style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
          >
            <v-stepper-step :complete="e1 > 1" step="1" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3" color="#193D6E"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.invoices.selectTypeOfWalletPay }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 px-4" v-if="!loading" style="display: flex; align-items: center; width: fit-content; margin: auto; gap: 30px; flex-wrap: wrap; justify-content: center;">
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'USD'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                        <div class="usd-balance">{{ "Wallet USD" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'USD'" color="#193D6E">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceUsd ? balanceUsd : 0) }} USD
                    </div>
                  </div>
                </v-card>
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'MXN'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                        <div class="usd-balance">{{ "Wallet MXN" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'MXN'" color="#193D6E">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceMxn ? balanceMxn : 0) }} MXN
                    </div>
                  </div>
                </v-card>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="selectedCurrency = null, dialogSendPay = false, getDashboard('sendPay')"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="selectedCurrency === null"
                    @click="e1 = 2"
                  > 
                    {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <v-container>
                <v-card style="box-shadow: none !important;"> 
                  <v-card-title style="display: flex; text-align: center; justify-content: center">
                    <span class="title font-weight-bold text-textblack">
                      {{ texts.dashboard.sendPayDetail }}
                    </span>
                  </v-card-title>
                  <v-card-text class="py-0">
                    <div class="mb-4">
                      <v-list rounded v-if="!isLoadingSuppliers">
                        <v-autocomplete
                          :items="suppliers"
                          filled
                          label="Contactos"
                          item-text="sNameAC"
                          return-object
                          v-model="selected"
                          @change="supplier = selected"
                          rounded
                        ></v-autocomplete>
                      </v-list>
                      <v-skeleton-loader
                        v-else
                        class="mx-auto"
                        type="image"
                      ></v-skeleton-loader>
                    </div>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="e1 = 1, selected = null"
                    >
                      {{ texts.modalForm.return }}
                    </v-btn>
                    <v-btn
                      color="#0075B8"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="selected == null"
                      @click="e1 = 3, getRate(selectedCurrency, supplier.sAccountCurrency)"
                    > 
                      {{ texts.modalForm.continue }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-container>
                <v-card style="box-shadow: none !important;">
                  <v-card-title class="pt-0" style="display: flex; justify-content: center; font-family: 'montserrat-bold'; font-size: 24px; color: #2E404E;">
                    {{ texts.dashboard.transferMoney }}
                  </v-card-title>
                  <v-card-text class="info-card">
                    <div class="text-center mb-12">
                      <div class="pa-3 mt-2" outlined style="display: flex; justify-content: space-between; background-color: #F2F2F2; border-radius: 10px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);">
                        <div style="text-align: start;">
                          <div class="subtitle-1 font-weight-bold text-textblack">
                            {{ "Cliente:" }}
                          </div>
                          <h2 class="text-h5 font-weight-bold text-center">
                            {{ supplier.sName }}
                          </h2>
                        </div>
                        <div style="text-align: end;">
                          <div class="subtitle-1 font-weight-bold text-textblack">
                            {{ "Saldo de la cuenta:" }}
                          </div>
                          <h2 class="text-h5 font-weight-bold text-center">
                            ${{ formatMoney(selectedCurrency == 'USD' ? balanceUsd : balanceMxn) }} {{ selectedCurrency }}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div class="my-6">
                      <v-text-field
                        outlined
                        :label="`De ${currencyMap[selectedCurrency]?.name}`"
                        type="number"
                        dense
                        :disabled="selectedCurrency != (supplier.sAccountCurrency) ? isLoadingRate : false"
                        hide-details
                        v-model="amounts[selectedCurrency]"
                        @change="selectedCurrency != (supplier.sAccountCurrency) ? calculatorAmount(amounts[selectedCurrency], false, selectedCurrency, supplier.sAccountCurrency) : null"
                        prefix="$"
                        class="mb-7"
                      >
                        <template v-slot:append>
                          <div class="d-flex align-center">
                            <img
                              :src="currencyMap[selectedCurrency]?.flag"
                              width="24"
                              height="24"
                              alt=""
                              class="rounded"
                            />
                            <h4 class="ml-2 font-weight-bold">{{ selectedCurrency }}</h4>
                          </div>
                        </template>
                      </v-text-field>
                      <v-text-field
                        outlined
                        :label="`A ${currencyMap[supplier.sAccountCurrency]?.name}`"
                        type="number"
                        dense
                        hide-details
                        v-if="selectedCurrency != (supplier.sAccountCurrency)"
                        :disabled="selectedCurrency != (supplier.sAccountCurrency) ? isLoadingRate : false"
                        v-model="amounts[supplier.sAccountCurrency]"
                        @change="(calculatorAmount(amounts[supplier.sAccountCurrency], true, selectedCurrency, supplier.sAccountCurrency))"
                        prefix="$"
                        class="mb-5"
                      >
                        <template v-slot:append>
                          <div class="d-flex align-center">
                            <img
                              :src="currencyMap[supplier.sAccountCurrency]?.flag"
                              width="24"
                              height="24"
                              alt=""
                              class="rounded"
                            />
                            <h4 class="ml-2 font-weight-bold">{{ supplier.sAccountCurrency }}</h4>
                          </div>
                        </template>
                      </v-text-field>
                    </div>
                    <div v-if="selectedCurrency === (supplier.sAccountCurrency) && selectedCurrency == 'USD'" class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                      <div class="mr-4" style="border-right: #0075B8 solid 4px; height: 35px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E;">
                          Al realizar un pago de USD a USD se aplicará un fee de $12.50 USD.
                        </div>
                      </div>
                    </div>
                    <div v-if="selectedCurrency != (supplier.sAccountCurrency)">
                      <v-row class="align-center">
                        <v-col class="pb-0">
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ texts.dashboard.exchangeRate }}
                          </div>
                        </v-col>
                        <v-col class="pb-0 d-flex justify-end">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="mr-1" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ "El cálculo se realizó con " + exchangeRateToday + " MXN" }}</span> 
                          </v-tooltip>
                          <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                            1 {{ baseCurrency }} = <span v-if="!isLoadingRate">${{ exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2) }}</span> <v-progress-circular v-else size="22" indeterminate class="ma-2" color="primary"></v-progress-circular> {{ supplier.sAccountCurrency }}
                          </h2>
                        </v-col>
                      </v-row>

                      <v-row class="align-center mt-5">
                        <v-col class="pb-0">
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ texts.dashboard.exchangeRateTodayDescription }}
                          </div>
                        </v-col>
                        <v-col class="pb-0 d-flex justify-end">
                          <h2 :class="{ 'text-red': countdownRate < 30, 'text-black': countdownRate >= 30 }" style="text-wrap: nowrap; font-size: 18px;">
                            {{ countdownRate }} {{ texts.dashboard.seconds }}
                          </h2>
                        </v-col>
                      </v-row>
                    </div>
                    
                    <v-row v-if="selectedCurrency != (supplier.sAccountCurrency)" class="align-center mt-5">
                      <v-col class="pb-0" :style="{ 'margin-bottom': selectedCurrency != (supplier.sAccountCurrency) ? '0' : '25px' }">
                        <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                          {{ "Total origin" }}
                        </div>
                      </v-col>
                      <v-col class="pb-0 d-flex justify-end">
                        <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                          ${{ amounts[selectedCurrency] ? formatMoney(amounts[selectedCurrency]) : 0 }} {{ selectedCurrency }}
                        </h2>
                      </v-col>
                    </v-row>

                    <v-row class="align-center mt-5 mb-4">
                      <v-col class="pb-0">
                        <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                          {{ selectedCurrency == (supplier.sAccountCurrency) ? "Cantidad a enviar" : texts.dashboard.totalConverted  }}
                        </div>
                      </v-col>
                      <v-col class="pb-0 d-flex justify-end">
                        <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                          ${{ amounts[supplier.sAccountCurrency] ? formatMoney(amounts[supplier.sAccountCurrency]) : 0 }} {{ supplier.sAccountCurrency }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="e1 = 2, selectedTypeOfPayment = '', stopRateTimer()"
                    >
                      {{ texts.modalForm.return }}
                    </v-btn>
                    <v-btn
                      color="#0075B8"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="!amounts[supplier.sAccountCurrency] || (selectedCurrency != (supplier.sAccountCurrency) ? isLoadingRate : false) || amounts[supplier.sAccountCurrency] == 0 || amounts[selectedCurrency] == 0 || parseFloat(amounts[selectedCurrency]) > (selectedCurrency == 'USD' ? balanceUsd : balanceMxn) || !hasValidExchangeRateForPayment"
                      @click="continueToPaymentDetail"
                    > 
                      {{ texts.modalForm.continue }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="4" class="pt-0">
              <v-container>
                <v-card style="box-shadow: none !important;">
                  <v-card-title class="pt-0" style="display: flex; justify-content: center; font-family: 'montserrat-bold'; font-size: 24px; color: #2E404E;">
                    {{ "Detalle del pago" }}
                  </v-card-title>
                  <v-card-text class="info-card" style="box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <p class="value">{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier.sAccountNumber">
                        <p class="label">Número de cuenta:</p>
                        <p class="value">{{ "*" + (supplier?.accountNumber ? (supplier?.accountNumber).slice(-4) : (supplier?.sAccountNumber).slice(-4)) }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment == 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de pago:</p>
                        <p class="value">{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment == 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <p class="value">{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div v-if="selectedTypeOfPayment == 'Window Spot' && selectedCurrency != (supplier.sAccountCurrency)" class="mb-4 py-3" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                      <div class="mr-4" style="border-right: #0075B8 solid 4px; height: 90px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
                          Al programar un Window Spot tienes que cumplir con las siguientes condiciones:
                        </div>
                        <ul style="padding-left: 16px; margin: 0; font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                          <li>Depositar el 100% del monto origen dentro de un plazo de {{ selectedCurrency == 'MXN' ? '3 horas' : '7 días' }}. Este monto será descontado de tu balance al ingresarlo y convertido al monto destino.</li>
                        </ul>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div style="display: flex; justify-content: space-between;" v-if="selectedCurrency != (supplier.sAccountCurrency)">
                        <p class="label">Tipo de cambio:</p>
                        <p class="value">{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="selectedCurrency != (supplier.sAccountCurrency)">
                        <p class="label">Monto origen:</p>
                        <p class="value">{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div class="mb-0" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto destino:</p>
                        <p class="value">{{ "$ " + formatMoney(amounts[supplier.sAccountCurrency]) + " " + (supplier.sAccountCurrency) }}</p>
                      </div>
                    </div>
                    <div class="info-block mt-2">
                      <v-textarea
                        class="pa-4"
                        rows="2"
                        :label="texts.dashboard.paymentConcept"
                        v-model="comment"
                        no-resize
                        hide-details
                      ></v-textarea>
                    </div>
                    <div v-if="selectedCurrency != (supplier.sAccountCurrency)">
                      <v-card class="d-flex pa-2 mt-4 mb-3" @click="selectedTypeOfPayment = 'Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between;">
                        <div>
                          <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Pago instantaneo" }}</div>
                          <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                            {{ "Al utilizar pago instantaneo se descontara de tu balance origen y se enviara a tu destinatario." }}
                          </div>
                        </div>
                        <v-icon v-if="selectedTypeOfPayment === 'Spot'" color="#193D6E">mdi-check-circle</v-icon>
                        <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                      </v-card>
                      <v-card class="d-flex pa-2" @click="selectedTypeOfPayment = 'Window Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between;">
                        <div>
                          <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Pago diferido" }}</div>
                          <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                            {{ "Al utilizar pago diferido se creara un window spot y te permitira depositar el monto origen y una vez se refleje se enviara a tu destinatario." }}
                          </div>
                        </div>
                        <v-icon v-if="selectedTypeOfPayment === 'Window Spot'" color="#193D6E">mdi-check-circle</v-icon>
                        <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                      </v-card>
                    </div>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="e1 = 3, getRate(selectedCurrency, supplier.sAccountCurrency), amounts = { MXN: null, USD: null }, selectedTypeOfPayment = null"
                    >
                      {{ texts.modalForm.return }}
                    </v-btn>
                    <v-btn
                      color="#0075B8"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="!comment || isLoading || ((selectedCurrency != (supplier.sAccountCurrency)) ? !selectedTypeOfPayment : false) || !hasValidExchangeRateForPayment"
                      @click="continueToOtpStep"
                    > 
                      {{ texts.modalForm.continue }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="5" class="pt-0">
              <v-container class="mt-1" style="max-width: 600px;">
                <v-card-title
                  class="pa-0"
                  style="display: flex; text-align: center; justify-content: center"
                >
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.twoFactor.twoFactor }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 pb-0" v-if="supplier">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row;">
                    <div>
                      <v-otp-input
                        v-model="otp"
                        length="6"
                        type="number"
                        color="#193D6E"
                      ></v-otp-input>
                      <p style="font-size: 14px; font-weight: 500">
                        {{ texts.twoFactor.enterCode }}
                      </p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 4"
                  >
                    {{ texts.modalForm.return }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="otp.length < 6 || !hasValidExchangeRateForPayment"
                    @click="confirmPaymentWithValidation"
                  > 
                    {{ texts.modalForm.confirmPay }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="6" class="pt-0">
              <v-btn icon @click="dialogSendPay = false, selectedCurrency = null, selected = null, selectedTypeOfPayment = '', comment = '', amounts = { MXN: null, USD: null }, getDashboard('sendPay')" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-card class="pa-6 mx-auto">
                <div v-if="loadingPayment" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando pago...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ selectedTypeOfPayment === 'Window Spot' ? "Pago programado correctamente!" : "Pago procesado correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el pago!
                  </v-card-title>
                </div>
                <v-card-text class="pb-0 px-0" >
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Payment concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="!supplier">
                        <p class="label">Número de cuenta:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "*" + (supplier?.accountNumber ? (supplier?.accountNumber).slice(-4) : (supplier?.sAccountNumber).slice(-4)) }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de pago:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (supplier.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier.sAccountCurrency]) + " " + (supplier.sAccountCurrency) }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogSendPayMassive" v-model="dialogSendPayMassive" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header v-if="e1 < 4" color="#193D6E" class="mt-5 mr-15 ml-15" elevation="0" 
            style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
          >
            <v-stepper-step :complete="e1 > 1" step="1" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3" color="#193D6E"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.invoices.selectTypeOfWalletPay }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 px-4" v-if="!loading" style="display: flex; align-items: center; width: fit-content; margin: auto; gap: 30px; flex-wrap: wrap; justify-content: center;">
                <v-card class="d-flex pa-6" outlined @click="selectMassPaymentCurrencyUSD()" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                        <div class="usd-balance">{{ "Wallet USD" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="massPaymentOriginCurrency === 'USD'" color="#193D6E">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceUsd ? balanceUsd : 0) }} USD
                    </div>
                  </div>
                </v-card>
                <v-card class="d-flex pa-6" outlined @click="selectMassPaymentCurrencyMXN()" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                        <div class="usd-balance">{{ "Wallet MXN" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="massPaymentOriginCurrency === 'MXN'" color="#193D6E">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceMxn ? balanceMxn : 0) }} MXN
                    </div>
                  </div>
                </v-card>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="massPaymentOriginCurrency = null, dialogSendPayMassive = false, getDashboard('sendPay')"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="massPaymentOriginCurrency === null"
                    @click="e1 = 2"
                  > 
                    {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <v-container>
                <v-card style="box-shadow: none !important;"> 
                  <v-card-title style="display: flex; text-align: center; justify-content: center">
                    <span class="title font-weight-bold text-textblack">
                      {{ texts.dashboard.sendPayDetail }}
                    </span>
                  </v-card-title>
                  <v-card-text class="py-0">
                    <v-row class="mt-4" v-for="(row, index) in massPaymentsRows" :key="row.id" style="border: 2px solid #dddddd; border-radius: 15px; padding: 20px; margin: 0px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);" >
                      <v-row align="center">
                        <v-col cols="12" style="display: flex; align-items: center;">
                          <v-autocomplete
                            :items="suppliers"
                            filled
                            rounded
                            dense
                            label="Contactos"
                            item-text="sNameAC"
                            return-object
                            v-model="row.supplier"
                            @change="onMassPaymentSupplierChange(row), getRateForMassRow(row)"
                            hide-details
                          ></v-autocomplete>
                          <v-btn class="ml-2" icon color="red" @click="removeMassPaymentRow(index)" :disabled="massPaymentsRows.length === 1">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row class="mt-4">
                        <v-col cols="12" md="4">
                          <v-text-field
                            outlined
                            :label="`De ${currencyMap[massPaymentOriginCurrency]?.name}`"
                            type="number"
                            dense
                            rounded
                            :loading="row.loadingRate"
                            :disabled="row.supplier?.sAccountCurrency !== massPaymentOriginCurrency && !row.exchangeRateReference"
                            hide-details
                            v-model="row.originAmount"
                            @change="row.supplier?.sAccountCurrency === massPaymentOriginCurrency ? row.destAmount = parseFloat(row.originAmount || 0).toFixed(2) : calculatorAmountForMassRow(row, row.originAmount, false)"
                            prefix="$"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="currencyMap[massPaymentOriginCurrency]?.flag"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ massPaymentOriginCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            outlined
                            v-if="row.supplier"
                            :label="`A ${row.supplier?.sAccountCurrency ? currencyMap[row.supplier.sAccountCurrency]?.name : ''}`"
                            type="number"
                            dense
                            rounded
                            hide-details
                            :disabled="row.supplier?.sAccountCurrency !== massPaymentOriginCurrency && !row.exchangeRateReference"
                            v-model="row.destAmount"
                            @change="row.supplier?.sAccountCurrency === massPaymentOriginCurrency ? row.originAmount = parseFloat(row.destAmount || 0).toFixed(2) : calculatorAmountForMassRow(row, row.destAmount, true)"
                            prefix="$"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="row.supplier?.sAccountCurrency ? currencyMap[row.supplier.sAccountCurrency]?.flag : ''"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ row.supplier?.sAccountCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            rounded
                            outlined
                            dense
                            :label="'Concepto de pago'"
                            v-model="row.comment"
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-if="row.supplier && row.supplier.sAccountCurrency !== massPaymentOriginCurrency">
                        <v-col cols="12">
                          <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin: 0px;">
                            <p class="label">Tipo de cambio:</p>
                            <p class="value" v-if="row.exchangeRateToday">{{ "$" + row.exchangeRateToday + " MXN" }}</p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-row>

                  <v-row>
                    <v-col cols="12" class="d-flex justify-center">
                      <v-btn
                        color="black"
                        v-if="massPaymentsRows.length < 10"
                        outlined
                        block
                        style="border-radius: 36px; text-transform: none; font-family: 'montserrat-semibold'; border: 2.4px dashed #757575;"
                        @click="addMassPaymentRow()"
                      >
                        <v-icon color="black" size="20">mdi-plus</v-icon>
                        {{ "Agregar otro pago" + " (" + massPaymentsRows.length + "/10)" }}
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row class="mt-6">
                    <v-col cols="12">
                      <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin: 0px; background-color: #F2F2F2; padding: 16px; border-radius: 12px;">
                        <div class="label">Costo total:</div>
                        <div class="value">${{ formatMoney(massPaymentTotalOrigin) }} {{ massPaymentOriginCurrency }}</div>
                      </div>
                    </v-col>
                  </v-row>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="e1 = 1, selected = null"
                    >
                      {{ texts.modalForm.return }}
                    </v-btn>
                    <v-btn
                      color="#0075B8"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="!canSubmitMassPayment"
                      @click="e1 = 3"
                    > 
                      {{ texts.modalForm.continue }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-container>
                <v-card style="box-shadow: none !important;">
                  <v-card-title class="pt-0" style="display: flex; justify-content: center; font-family: 'montserrat-bold'; font-size: 24px; color: #2E404E;">
                    {{ texts.dashboard.transferMoney }}
                  </v-card-title>
                  <v-card-text class="py-6 px-4">
                    <v-row class="mt-6">
                      <v-col cols="12">
                        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin: 0px; background-color: #F2F2F2; padding: 16px; border-radius: 12px;">
                          <div class="label">Balance:</div>
                          <div class="value">{{ "$" + formatMoney(massPaymentOriginCurrency === 'USD' ? balanceUsd : balanceMxn) + " " + massPaymentOriginCurrency }}</div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="py-0">
                      <v-col cols="12">
                        <h4 style="font-family: 'montserrat-bold';">{{ "Detalle de pagos (" + massPaymentsRows.length + ")" }}</h4>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr style="background-color: #f5f5f5;">
                                <th style="font-family: 'montserrat-bold'; color: black;">Beneficiario</th>
                                <th style="font-family: 'montserrat-bold'; color: black;">Monto Origen</th>
                                <th style="font-family: 'montserrat-bold'; color: black;">Monto Destino</th>
                                <th style="font-family: 'montserrat-bold'; color: black;">Concepto</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, index) in massPaymentsRows" :key="row.id">
                                <td>{{ row.supplier?.sNameAC }}</td>
                                <td>${{ formatMoney(row.originAmount) }} {{ massPaymentOriginCurrency }}</td>
                                <td>${{ formatMoney(row.destAmount) }} {{ row.supplier?.sAccountCurrency }}</td>
                                <td>{{ row.comment || '-' }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <v-row class="mt-6">
                      <v-col cols="12">
                        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin: 0px; background-color: #F2F2F2; padding: 16px; border-radius: 12px;">
                          <div class="label">Costo total:</div>
                          <div class="value">${{ formatMoney(massPaymentTotalOrigin) }} {{ massPaymentOriginCurrency }}</div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="e1 = 2"
                    >
                      {{ texts.modalForm.return }}
                    </v-btn>
                    <v-btn
                      color="#0075B8"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      @click="continueToOtpStepFromMassPayment()"
                    > 
                      {{ texts.modalForm.continue }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="4" class="pt-0">
              <v-container class="mt-1" style="max-width: 600px;">
                <v-card-title
                  class="pa-0"
                  style="display: flex; text-align: center; justify-content: center"
                >
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.twoFactor.twoFactor }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 pb-0" v-if="supplier">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row;">
                    <div>
                      <v-otp-input
                        v-model="otp"
                        length="6"
                        type="number"
                        color="#193D6E"
                      ></v-otp-input>
                      <p style="font-size: 14px; font-weight: 500">
                        {{ texts.twoFactor.enterCode }}
                      </p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 3"
                  >
                    {{ texts.modalForm.return }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="otp.length < 6"
                    @click="sendMassPayment(), e1 = 5"
                  > 
                    {{ texts.modalForm.confirmPay }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="5" class="pt-0">
              <v-card class="pa-6 mx-auto">
                <v-card-text class="py-6 px-4">
                <v-row style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
                  <v-col cols="12" class="text-center">
                    <div v-if="massPaymentLoading" class="text-center">
                      <v-progress-circular indeterminate color="black" size="64"></v-progress-circular>
                      <h3 class="mt-6" style="font-family: 'montserrat-bold'; color: black;">{{ "Procesando tu pago masivo..." }}</h3>
                    </div>

                    <div v-else-if="massPaymentSuccess" class="text-center">
                      <h3 style="font-family: 'montserrat-bold'; font-size: 24px;" :style="{ color: massPaymentFailedCount > 0 ? '#F57C00' : '#12A150' }">
                        {{ massPaymentFailedCount > 0 ? 'Pago masivo procesado con observaciones' : '¡Pago masivo realizado exitosamente!' }}
                      </h3>
                    </div>

                    <div v-else class="text-center">
                      <v-icon size="80" color="#D32F2F">mdi-alert-circle</v-icon>
                      <h3 style="font-family: 'montserrat-bold'; color: #D32F2F; font-size: 24px;">{{ "Error al procesar el pago" }}</h3>
                      <p class="mt-4" style="font-family: 'montserrat-regular'; color: #666; font-size: 16px;">
                        {{ massPaymentResultMessage }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="!massPaymentLoading && massPaymentResults.length > 0" class="mt-6">
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #f5f5f5;">
                            <th style="font-family: 'montserrat-bold'; color: black;">Proveedor</th>
                            <th style="font-family: 'montserrat-bold'; color: black;">Monto Origen</th>
                            <th style="font-family: 'montserrat-bold'; color: black;">Monto Destino</th>
                            <th style="font-family: 'montserrat-bold'; color: black;">Estatus</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in massPaymentResults" :key="row.id">
                            <td>{{ row.beneficiaryName }}</td>
                            <td>${{ formatMoney(row.originAmount) }} {{ row.originCurrency }}</td>
                            <td>${{ formatMoney(row.destAmount) }} {{ row.destCurrency }}</td>
                            <td>
                              <v-chip
                                :color="row.success === true ? 'success' : 'error'"
                                text-color="white"
                                small
                              >
                                {{ row.success === true ? 'Exitoso' : 'Fallido' }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="pa-6" style="display: flex; justify-content: center;" v-if="!massPaymentLoading">
                <v-btn
                  elevation="4"
                  class="mr-2 px-10"
                  style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  @click="resetMassPaymentDialog(), getDashboard('bulkPayment')"
                >
                  {{ "Cerrar" }}
                </v-btn>
              </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogConvert" v-model="dialogConvert" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1">
          <v-stepper-header
            color="#0075B8"
            v-if="e1 < 4" 
            class="mt-5 mr-15 ml-15"
            elevation="0"
            style="
              justify-content: center;
              align-items: center;
              justify-items: center;
              align-content: center;
              box-shadow: none;
            "
          >
            <v-stepper-step :complete="e1 > 1" step="1" color="#0075B8"> </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="#0075B8"> </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3" color="#0075B8"> </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ texts.invoices.selectTypeConversion }}</span> 
                </v-card-title>
                <v-card-text class="py-6" v-if="!loading">
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" outlined :class="{ 'selected-card': selectedCard === 2 }" @click="selectedCard = 2" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ "Spot" }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify">{{ texts.payments.paySeparateDescription }}</div>
                      </div>
                      <v-icon v-if="selectedCard === 2" color="#193D6E">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" :disabled="isDisabledForward" outlined :class="{ 'selected-card': selectedCard === 3 }" @click="selectedCard = 3" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ "Forward" }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify"> {{isDisabledForward ? texts.dashboard.payForwardDescriptionDisabled : texts.payments.payForwardDescription }}</div>
                      </div>
                      <v-icon v-if="selectedCard === 3" color="#193D6E">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" :disabled="isDisabledWindow" outlined :class="{ 'selected-card': selectedCard === 4 }" @click="selectedCard = 4" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ "Window Spot" }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify"> {{isDisabledWindow ? texts.dashboard.payForwardDescriptionDisabled : texts.payments.payForwardDescription }}</div>
                      </div>
                      <v-icon v-if="selectedCard === 4" color="#193D6E">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    color="#0075B8"
                    elevation="8"
                    class="mr-2 px-10"
                    style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="dialogConvert = false, getDashboard('convert')"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="selectedCard === null"
                    @click="e1 = 2, selectedCard != 3 ? getRate(baseCurrency, targetCurrency) : (null, amounts = { MXN: null, USD: null }, warranty = null)"
                  > 
                    {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-0">
              <v-card class="pa-6 mx-auto">
                <v-card-title class="pt-0 text-center font-weight-bold text-textblack" style="display: flex; justify-content: center">
                  {{ "Selecciona el monto que desea convertir" }}
                </v-card-title>
                <v-card-subtitle class="text-center font-weight-bold text-textblack" style="display: flex; justify-content: center">
                  {{ "Elige la moneda de origen y destino" }}
                </v-card-subtitle>
                <v-card-text>
                  <div class="text-center">
                    <v-card class="pa-3 mt-2" outlined style="background-color: #F2F2F2; border-radius: 10px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);">
                      <div class="subtitle-1 font-weight-bold text-textblack">
                        {{ "Saldo de la cuenta:" }}
                      </div>
                      <h2 class="text-h5 font-weight-bold text-center">
                        ${{ formatMoney(baseCurrency == 'USD' ? balanceUsd : balanceMxn) }} {{ baseCurrency }}
                      </h2>
                    </v-card>
                  </div>

                  <div class="d-flex justify-center my-9" >
                    <div class="px-4 py-2" style="display: flex; background-color: #D9D9D9; border-radius: 30px;">
                      <div class="d-flex align-center px-2" style="background-color: #FFFFFF; border-radius: 20px;">
                        <img
                          :src="currencyMap[baseCurrency]?.flag"
                          width="34"
                          height="24"
                          style="border-radius: 20px;"
                          alt=""
                        />
                        <h4 class="ml-2 font-weight-bold">{{ baseCurrency }}</h4>
                      </div>
                      <v-btn color="#0075B8" icon @click="swapCurrencies()">
                        <v-icon color="black">mdi-swap-horizontal</v-icon>
                      </v-btn>
                      <div class="d-flex align-center px-2" style="background-color: #FFFFFF; border-radius: 20px;">
                        <img
                          :src="currencyMap[targetCurrency]?.flag"
                          width="34"
                          height="24"
                          style="border-radius: 20px;"
                          alt=""
                        />
                        <h4 class="ml-2 font-weight-bold">{{ targetCurrency }}</h4>
                      </div>
                    </div>
                  </div>
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dDateForward"
                    persistent
                    v-if="selectedCard === 3"
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dDateForward"
                        :label="texts.dashboard.selectDateForward"
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        hide-details
                        class="mb-8"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dDateForward"
                      :min="today"
                      :allowed-dates="onlyWeekdays"
                      :max="limit"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(dDateForward), getForwardRate(0, false), amounts = { MXN: null, USD: null }"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  
                  <div class="mb-4">
                    <v-text-field
                      outlined
                      :label="`De ${currencyMap[baseCurrency]?.name}`"
                      type="number"
                      dense
                      hide-details
                      :disabled="selectedCard === 3 && !dDateForward || isLoadingRate"
                      v-model="amounts[baseCurrency]"
                      @change="selectedCard != 3 ? calculatorAmount(amounts[baseCurrency], false, baseCurrency, targetCurrency) : getForwardRate(amounts[baseCurrency], false)"
                      prefix="$"
                      class="mb-7"
                    >
                      <template v-slot:append>
                        <div class="d-flex align-center">
                          <img
                            :src="currencyMap[baseCurrency]?.flag"
                            width="24"
                            height="24"
                            alt=""
                            class="rounded"
                          />
                          <h4 class="ml-2 font-weight-bold">{{ baseCurrency }}</h4>
                        </div>
                      </template>
                    </v-text-field>
                    <v-text-field
                      outlined
                      :label="`A ${currencyMap[targetCurrency]?.name}`"
                      type="number"
                      :disabled="selectedCard === 3 && !dDateForward || isLoadingRate"
                      dense
                      v-model="amounts[targetCurrency]"
                      @change="selectedCard != 3 ? calculatorAmount(amounts[targetCurrency], true, baseCurrency, targetCurrency) : getForwardRate(amounts[targetCurrency], true)"
                      prefix="$"
                      class="mb-5"
                    >
                      <template v-slot:append>
                        <div class="d-flex align-center">
                          <img
                            :src="currencyMap[targetCurrency]?.flag"
                            width="24"
                            height="24"
                            alt=""
                            class="rounded"
                          />
                          <h4 class="ml-2 font-weight-bold">{{ targetCurrency }}</h4>
                        </div>
                      </template>
                    </v-text-field>
                  </div>

                  <v-row class="align-center">
                    <v-col class="pb-0">
                      <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                        {{ texts.dashboard.exchangeRate }}
                      </div>
                    </v-col>
                    <v-col class="pb-0 d-flex justify-end">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="mr-1" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ "El cálculo se realizó con " + exchangeRateToday + " MXN" }}</span> 
                      </v-tooltip>
                      <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                        1 {{ "USD" }} = <span v-if="!isLoadingRate">${{ exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2) }}</span> <v-progress-circular v-else size="22" indeterminate class="ma-2" color="primary"></v-progress-circular> {{ "MXN" }}
                      </h2>
                    </v-col>
                  </v-row>

                  <v-row class="align-center mt-5" v-if="selectedCard == 3">
                    <v-col class="pb-0">
                      <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                        {{ "Garantia" }}
                      </div>
                    </v-col>
                    <v-col class="pb-0 d-flex justify-end">
                      <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                        ${{ formatMoney(warranty) }} {{ baseCurrency }}
                      </h2>
                    </v-col>
                  </v-row>

                  <v-row class="align-center mt-5" v-if="selectedCard != 3">
                    <v-col class="pb-0">
                      <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                        {{ texts.dashboard.exchangeRateTodayDescription }}
                      </div>
                    </v-col>
                    <v-col class="pb-0 d-flex justify-end">
                      <h2 :class="{ 'text-red': countdownRate < 30, 'text-black': countdownRate >= 30 }" style="text-wrap: nowrap; font-size: 18px;">
                        {{ countdownRate }} {{ texts.dashboard.seconds }}
                      </h2>
                    </v-col>
                  </v-row>
                  <v-row class="align-center mt-5">
                    <v-col class="pb-0">
                      <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                        {{ "Total origin" }}
                      </div>
                    </v-col>
                    <v-col class="pb-0 d-flex justify-end">
                      <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                        ${{ amounts[baseCurrency] ? formatMoney(amounts[baseCurrency]) : 0 }} {{ baseCurrency }}
                      </h2>
                    </v-col>
                  </v-row>

                  <v-row class="align-center mt-5 mb-4">
                    <v-col class="pb-0">
                      <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                        {{ texts.dashboard.totalConverted }}
                      </div>
                    </v-col>
                    <v-col class="pb-0 d-flex justify-end">
                      <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                        ${{ amounts[targetCurrency] ? formatMoney(amounts[targetCurrency]) : 0 }} {{ targetCurrency }}
                      </h2>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    color="#0075B8"
                    elevation="8"
                    class="mr-2 px-10"
                    style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 1, amounts = { MXN: null, USD: null }, dDateForward = null, stopRateTimer()"
                  >
                    {{ texts.modalForm.return }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="!amounts[baseCurrency] || isLoadingRate || (selectedCard !== 4 && parseFloat(amounts[baseCurrency]) > (baseCurrency == 'USD' ? balanceUsd : balanceMxn)) || !hasValidExchangeRateForConversion"
                    @click="continueToConvertDetail"
                  > 
                    {{ texts.modalForm.continue }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-card class="px-6 py-0 mx-auto" :width="selectedCard === 2 ? 500 : 900">
                <v-card-title class="pt-0 text-center font-weight-bold text-textblack" style="display: flex; justify-content: center">
                  {{ "Detalle del " + (selectedCard === 2 ? "Spot" : (selectedCard === 3 ? "Forward" : "Window Spot")) }}
                </v-card-title>
                <v-card-text class="pb-0">
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <p class="value">
                          <v-chip v-if="selectedCard == 2" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedCard == 3" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                            {{ "Forward" }}
                          </v-chip>
                          <v-chip v-else-if="selectedCard == 4" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de conversión:</p>
                        <p class="value">{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedCard === 3" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha programada:</p>
                        <p class="value">{{ dDateForward }}</p>
                      </div>
                      <div v-if="selectedCard === 4" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <p class="value">{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div v-if="selectedCard === 3" class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                      <div class="mr-4" style="border-right: #0075B8 solid 4px; height: 120px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
                          Al programar un Forward tienes que cumplir con las siguientes dos condiciones:
                        </div>
                        <ul style="padding-left: 16px; margin: 0; font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                          <li>La fecha seleccionada es la fecha en la cual se ejecutará el pago pactado. La carga de fondos debe efectuarse previo al fin del plazo.</li>
                          <li>Tendrás que hacer un depósito del 5% de los fondos totales del Futuro, los cuales serán restados de tu balance origen.</li>
                        </ul>
                      </div>
                    </div>
                    <div v-if="selectedCard === 4" class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                      <div class="mr-4" style="border-right: #0075B8 solid 4px; height: 120px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
                          Al programar un Window Spot tienes que cumplir con las siguientes condiciones:
                        </div>
                        <ul style="padding-left: 16px; margin: 0; font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                          <li>Depositar el 100% del monto origen dentro de un plazo de {{ baseCurrency == 'MXN' ? '3 horas' : '7 días' }}. Este monto será descontado de tu balance al ingresarlo y convertido al monto destino.</li>
                        </ul>
                      </div>
                    </div>
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <p class="value">{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCard === 3" style="display: flex; justify-content: space-between;">
                        <p class="label">5% of the total Forward funds:</p>
                        <p class="value">{{ "$ " + formatMoney((amounts[baseCurrency] * .05)) + " " + baseCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <p class="value">{{ "$ " + formatMoney(amounts[baseCurrency]) + " " + baseCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Monto destino:</p>
                        <p class="value">{{ "$ " + formatMoney(amounts[targetCurrency]) + " " + targetCurrency }}</p>
                      </div>
                    </div>
                    <div v-if="selectedCard === 3" class="mb-0" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                      <div class="mr-4" style="border-right: #FCCA3D solid 4px; height: 120px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
                          {{ texts.invoices.forwardConditions3 }}
                        </div>
                        <ul style="padding-left: 16px; margin: 0; font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                          <div>{{ texts.invoices.forwardConditions4 }} {{ texts.invoices.forwardConditions5 }}</div>
                          <v-checkbox color="primary" v-model="acceptWarranty" hide-details class="pb-5">
                            <template v-slot:label>
                              <div style="font-family: 'montserrat-semibold'; font-size: 14px; color: #2E404E;">
                                {{ texts.invoices.forwardConditions6 }} <span style="font-size: 18px; font-weight: bold;">{{ "$ " + formatMoney((amounts[baseCurrency] * .05)) + " " + baseCurrency }}</span> {{ texts.invoices.forwardConditions7 }}
                              </div>
                            </template>
                          </v-checkbox>
                        </ul>
                      </div>
                    </div>
                  </v-card>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      color="#0075B8"
                      elevation="4"
                      class="mr-2 px-10"
                      style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="e1 = 2, selectedCard != 3 ? getRate(baseCurrency, targetCurrency) : (null, warranty = null, acceptWarranty = false), amounts = { MXN: null, USD: null }, dDateForward = null"
                    >
                      {{ texts.modalForm.return }}
                    </v-btn>
                    <v-btn
                      color="#0075B8"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="!amounts[baseCurrency] || isLoading || (selectedCard === 3 && !acceptWarranty) || !hasValidExchangeRateForConversion"
                      @click="continueToConvertOtpStep"
                    > 
                      {{ texts.modalForm.continue }}
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-container class="mt-1" style="max-width: 600px;">
                <v-card-title
                  class="pa-0"
                  style="display: flex; text-align: center; justify-content: center"
                >
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.twoFactor.twoFactor }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 pb-0" v-if="supplier">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row;">
                    <div>
                      <v-otp-input
                        v-model="otp"
                        length="6"
                        type="number"
                        color="#193D6E"
                      ></v-otp-input>
                      <p style="font-size: 14px; font-weight: 500">
                        {{ texts.twoFactor.enterCode }}
                      </p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 3"
                  >
                    {{ texts.modalForm.return }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="otp.length < 6 || !hasValidExchangeRateForConversion"
                    @click="confirmConvertWithValidation"
                    > 
                    {{ texts.modalForm.confirm }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="5" class="pt-0">
              <v-btn icon @click="dialogConvert = false, getDashboard('convert')" :disabled="loadingConversion" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-card class="pa-6 mx-auto">
                <div v-if="loadingConversion" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando conversión...</p>
                </div>
                <div v-if="conversionError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ (selectedCard === 2 ? "Spot" : (selectedCard === 3 ? "Forward" : "Window Spot")) + " realizado correctamente!"}}
                  </v-card-title>
                </div>
                <div v-if="conversionError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al realizar la conversion!
                  </v-card-title>
                </div>

                <v-card-text class="pb-0 px-0 pt-0">
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>
                          <v-chip v-if="selectedCard == 2" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedCard == 3" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                            {{ "Forward" }}
                          </v-chip>
                          <v-chip v-else-if="selectedCard == 4" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de conversión:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedCard === 3" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha programada:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ dDateForward }}</p>
                      </div>
                      <div v-if="selectedCard === 4" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCard === 3" style="display: flex; justify-content: space-between;">
                        <p class="label">5% of the total Forward funds:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney((amounts[baseCurrency] * .05)) + " " + baseCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[baseCurrency]) + " " + baseCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Monto destino:</p>
                        <v-skeleton-loader v-if="loadingConversion" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[targetCurrency]) + " " + targetCurrency }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogRewards" v-model="dialogRewards" persiten width="884" class="pa-8">
      <v-card class="container">
        <v-card-title class="d-flex justify-space-between align-center">
          <div style="display: flex; align-items: center; width: 100%">
            <v-btn style="background-color: #efefef; border-radius: 15px;" text @click="dialogDetailFresherCoins = true">
              {{ "¿Cómo obtener fresher coins?" }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogRewards = false, getDashboard('rewards')">
              <v-icon color="#2E404E">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="py-6 pt-0">
          <div class="mb-4" style="display: flex; flex-direction: column; align-items: center;">
            <div class="font-weight-bold text-textblack mt-4" style="font-size: 34px; text-align: center; width: 482px; margin-bottom: 20px; color: #000000">
              {{ "Catálogo de Recompensas" }}
            </div>
            <div class="font-weight-bold text-textblack mb-4" style="font-size: 16px; text-align: center;">
              {{ "Explora nuestro catálogo y canjea productos exclusivos con las fresher coins que generas al realizar conversiones con nosotros. Aprovecha tus recompensas y disfruta de beneficios por cada operación." }}
            </div>
            <v-divider></v-divider>
            <div class="mt-2">
              <div class="toggle-container">
                <v-btn
                  :class="['toggle-button', { active: selectedTab === 'catalogo' }]"
                  @click="changeTab('catalogo')"
                  elevation="0"
                  style="font-size: 12px; font-weight: 500; text-transform: none;"
                >
                  Catálogo
                </v-btn>
                <v-btn
                  :class="['toggle-button', { active: selectedTab === 'mis-productos' }]"
                  @click="changeTab('mis-productos')"
                  elevation="0"
                  style="font-size: 12px; font-weight: 500; text-transform: none;"
                >
                  Mis productos
                </v-btn>
              </div>
            </div>
          </div>
          <v-row justify="start" align="center" class="d-flex ma-0 mb-4" v-if="selectedTab === 'catalogo'">
            <v-col>
              <v-tabs v-model="selectedStatus" background-color="transparent" show-arrows>
                <v-tab
                  class="global-tab"
                  style="font-family: 'montserrat-bold';"
                  v-for="item in categorias"
                  :key="item.sCatId"
                  :value="item.sCatId"
                >
                  {{ item.sName }}
                </v-tab>
                <v-tabs-slider></v-tabs-slider>
              </v-tabs>
            </v-col>
          </v-row>
         
          <div class="px-10 d-flex mb-4" style="flex-wrap: wrap; gap: 19px;" v-if="selectedTab === 'catalogo'">
            <template v-for="item in images">
              <v-img
                v-if="selectedStatus == item.sCatId"
                style="border-radius: 25px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);"
                position="center center"
                class="grey lighten-2"
                :width="item.sWidth"
                :max-width="item.sWidth"
                :height="item.sHeight"
                :max-height="item.sHeight"
                :src="item.sImage"
              >
                <div style="position: absolute; z-index: 8; bottom: 9px; right: 13px; background-color: #61A3D9; color: white; border-radius: 18px;">
                  <v-icon @click="openDialogProduct(item)" color="white">mdi-plus</v-icon>
                </div>
              </v-img>
            </template>
          </div>
          <div class="font-weight-bold text-textblack mt-8 mb-4" style="font-size: 16px; text-align: center;" v-if="selectedTab === 'mis-productos'">
              {{ "Todavía no cuentas con productos canjeados." }}
            </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog  v-if="dialogProduct" v-model="dialogProduct" persisten width="503">
      <v-card>
        <v-card-text class="py-6 pt-8">
          <div class="d-flex mb-4" style="flex-wrap: wrap; gap: 20px;">
            <v-img
              style="border-radius: 25px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);"
              contain
              :src="selectedItem?.sImage"
              class="grey lighten-2"
            >
            </v-img>
          </div>
          <div class="mb-4" style="display: flex; flex-direction: column;">
            <div class="font-weight-bold text-textblack" style="font-size: 24px; width: 272px; margin-bottom: 20px; color: #000000; font-family: 'montserrat-bold';">
              {{ selectedItem?.sName }}
            </div>
            <div class="d-flex mb-2" style="align-items: center;">
              <img src="@/assets/icons/fresherCoin.svg" width="24" heigth="24" alt="" />
              <div class="ml-2" style="font-size: 14px; font-family: 'montserrat-semibold';;">
                {{ selectedItem?.sPrice + " Fresher coins"}}
              </div>
            </div>
            <div class="font-weight-bold text-textblack mt-3" style="font-size: 14px; text-align: left; font-family: 'montserrat-semibold';">
              {{ "Contacta a tu ejecutivo de cuenta para obtener este artículo." }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogDetailFresherCoins" v-model="dialogDetailFresherCoins" persisten width="603">
      <v-card>
        <v-card-text class="py-6 pt-8">
          <div class="font-weight-bold text-textblack mb-7" style="text-align: center; font-size: 24px; margin-bottom: 20px; color: #000000; font-family: 'montserrat-bold';">
            {{ "Cómo se generan las Fresher Coins y para qué sirven" }}
          </div>
          <div style="display: flex; justify-content: space-around;">
            <div class="mb-4" style="display: flex; flex-direction: column; align-items: center; border-radius: 25px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25); padding: 20px;">
              <div class="font-weight-bold text-textblack" style=" font-size: 24px; width: 100px; text-align: center; margin-bottom: 20px; color: #000000; font-family: 'montserrat-bold';">
                {{ "FX" }}
              </div>
              <div class="d-flex mb-2" style="align-items: center;">
                <div class="ml-2" style="font-size: 14px; font-family: 'montserrat-semibold';">
                  {{ "500 USD converted = 1 "}}
                </div>
                <img class="ml-1" src="@/assets/icons/fresherCoin.svg" width="24" heigth="24" alt="" />
              </div>
            </div>
            <div class="mb-4" style="display: flex; flex-direction: column; align-items: center; border-radius: 25px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25); padding: 20px;">
              <div class="font-weight-bold text-textblack" style=" font-size: 24px; width: 100px; text-align: center; margin-bottom: 20px; color: #000000; font-family: 'montserrat-bold';">
                {{ "FWD" }}
              </div>
              <div class="d-flex mb-2" style="align-items: center;">
                <div class="ml-2" style="font-size: 14px; font-family: 'montserrat-semibold';;">
                  {{ "166 USD converted = 1"}}
                </div>
                <img class="ml-1" src="@/assets/icons/fresherCoin.svg" width="24" heigth="24" alt="" />
              </div>
            </div>
          </div>
          <div class="font-weight-bold text-textblack" style="font-size: 14px; text-align: left; font-family: 'montserrat-semibold';">
            {{ "La única plataforma que te recompensa por realizar tus cambios de divisas." }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogToursList" max-width="800" persistent scrollable>
      <v-card style="border-radius: 16px;">
        <v-card-title style="font-family: 'montserrat-bold'; font-size: 24px;">
          Actualizaciones disponibles
        </v-card-title>

        <v-divider class="my-3"></v-divider>

        <v-card-text style="max-height: 500px; overflow-y: auto;">
          <v-list>
            <v-list-item
              v-for="tour in availableTours"
              :key="tour.id"
              @click="viewTourDetail(tour)"
              style="border: 1px solid #E0E0E0; border-radius: 12px; margin-bottom: 12px; cursor: pointer;"
              class="pa-4 tour-item"
            >
              <template v-slot:default>
                <div class="d-flex justify-space-between align-center w-100">
                  <div class="flex-grow-1">
                    <div style="font-family: 'montserrat-bold'; font-size: 18px; color: #000;">
                      {{ tour.title }}
                    </div>
                    <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #666; margin-top: 8px;">
                      {{ truncateText(tour.description, 120) }}
                    </div>
                    <div style="font-family: 'montserrat-medium'; font-size: 12px; color: #999; margin-top: 8px;">
                      {{ formatDate(tour.created_at) }}
                    </div>
                  </div>

                  <div class="ml-4 d-flex flex-column align-center">
                    <v-chip
                      v-if="tour.seen"
                      small
                      color="#E0E0E0"
                      text-color="black"
                      style="font-family: 'montserrat-bold';"
                    >
                      Visto
                    </v-chip>
                    <v-chip
                      v-else
                      small
                      color="#2f66ff"
                      text-color="white"
                      style="font-family: 'montserrat-bold';"
                    >
                      Nuevo
                    </v-chip>
                  </div>
                </div>
              </template>
            </v-list-item>

            <v-empty-state
              v-if="availableTours.length === 0"
              icon="mdi-inbox-outline"
              title="Sin actualizaciones"
              text="No hay actualizaciones disponibles en este momento"
            />
          </v-list>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 d-flex justify-end">
          <v-btn text color="black" @click="closeToursDialog()" rounded>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPreviewTour" max-width="900" persistent>
      <v-card style="border-radius: 16px; overflow: hidden;">
        <div v-if="currentPreviewStep">
          <div class="preview-image-wrap">
            <v-img
              :src="currentPreviewStep.image_signed_url || currentPreviewStep.image_url"
              contain
              height="420"
              class="preview-image"
            />
            <v-btn icon class="preview-close-btn" @click="closePreviewTour()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="pa-8">
            <div class="preview-title">{{ currentPreviewStep.title }}</div>
            <div class="preview-description">{{ currentPreviewStep.description }}</div>

            <div class="preview-progress mt-6 mb-6">
              <div
                v-for="(step, idx) in previewTour.steps"
                :key="step.id || idx"
                class="preview-progress-segment"
                :class="{
                  'active': idx <= previewStepIndex,
                  'current': idx === previewStepIndex
                }"
              />
            </div>

            <div class="d-flex align-center justify-space-between">
              <v-btn
                outlined
                rounded
                class="px-8"
                @click="isFirstPreviewStep ? closePreviewTour() : goPreviousPreviewStep()"
                style="border-radius: 36px; font-family: 'montserrat-bold'; text-transform: none;"
              >
                {{ isFirstPreviewStep ? 'Cerrar' : 'Anterior' }}
              </v-btn>

              <div class="preview-counter">
                {{ previewStepIndex + 1 }} de {{ previewTour.steps.length }}
              </div>

              <v-btn
                color="#000000"
                class="white--text px-8"
                rounded
                style="border-radius: 36px; font-family: 'montserrat-bold'; text-transform: none;"
                @click="goNextPreviewStep()"
              >
                {{ isLastPreviewStep ? 'Finalizar' : 'Siguiente' }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import * as XLSX from "xlsx";

export default {
  name: "DashboardView",
  data() {
    return {
      dialogSendPayMassive: false,
      massPaymentsRows: [],
      massPaymentOriginCurrency: null,
      massPaymentSuccess: false,
      massPaymentResultMessage: '',
      massPaymentResults: [],
      massPaymentSuccessfulCount: 0,
      massPaymentFailedCount: 0,
      massPaymentTotalPayments: 0,
      massPaymentLoading: false,
      selectedCurrency: null,
      selectedItem: "",
      acceptWarranty: false,
      dialogRewards: false,
      clockTime: "",
      dialogDetailFresherCoins: false,
      selectedTab: "catalogo",
      selected: null,
      currentDate: moment(),
      currentDateCdmx: moment().clone().utcOffset("-06:00"),
      isDisabledForward: false,
      isDisabledWindow: false,
      lastUpdateclockTime: "",
      texts: "",
      amountForexUSD: 0,
      amountForexMXN: 0,
      amountForwardUSD: 0,
      selectedTypeOfPayment: "Spot",
      dialogProduct: false,
      amountForwardMXN: 0,
      amountForexRealUSD: 0,
      reverseForward: false,
      amountForwardDest: 0,
      modalAlerts: false,
      dialogAlerts: false,
      alerts: [],
      amountForwardRealUSD: 0,
      dialogForward: false,
      dialogMassivePayments: false,
      loading: true,
      dialogConvert: false,
      modal: false,
      otp: "",
      selectedItem: null,
      headersMassivePayment: [
        {
          text: "Destinatario",
          value: "sPaymentRecipient",
          align: "center",
          sortable: false,
        },
        { text: "Email", value: "sEmail", align: "center", sortable: false },
        {
          text: "Valor a pagar (MXN)",
          value: "dAmount",
          align: "center",
          sortable: false,
        },
        { text: "RFC", value: "sRfc", align: "center", sortable: false },
        { text: "Banco destino", value: "sBankName", align: "center", sortable: false },
        {
          text: "Cuenta clabe",
          value: "sAccountNumber",
          align: "center",
          sortable: false,
        },
        { text: "Comentarios", value: "sComments", align: "center", sortable: false },
      ],
      isLoadingCalculatorUsd: false,
      isLoadingCalculatorMxn: false,
      referenceCurrency: "0",
      isLoading: false,
      isRegisterEfex: true,
      exchangeRateData: [],
      exchangeRateDataPaid: [],
      exchangeRateDataSeparate: [],
      balance: "0",
      items: [],
      selectedStatus: "453f47d8-d5ad-4159-be49-b48b0f04caa5",
      today: null,
      tab: 0,
      contacts: [],
      itemsSelected: [],
      dDateForward: null,
      comment: "",
      categorias: [
        { sName: "Tech", sCatId: "0" },
        { sName: "Hieleras", sCatId: "1" },
        { sName: "Termos", sCatId: "2" },
        { sName: "Deportes", sCatId: "3" },
        { sName: "Ropa", sCatId: "4" },
        { sName: "Otros", sCatId: "5" },
      ],
      images: [        
        { sName: "Apple - AirPods Max", sPrice: "52,900", sDesc: "", sImage: require('@/assets/Catalogo/Apple - AirPods Max.jpg'), sCatId: "0", sWidth: "229", sHeight: "138" },
        { sName: "Apple - AirPods Pro 2", sPrice: "18,000", sDesc: "", sImage: require('@/assets/Catalogo/Apple - AirPods Pro 2.jpg'), sCatId: "0", sWidth: "145", sHeight: "138" },
        { sName: "Apple Watch Series 10", sPrice: "24,900", sDesc: "", sImage: require('@/assets/Catalogo/Apple Watch Series 10.jpg'), sCatId: "0", sWidth: "145", sHeight: "138" },
        { sName: "Bounce™", sPrice: "15,000", sDesc: "", sImage: require('@/assets/Catalogo/Bounce™.jpg'), sCatId: "0", sWidth: "145", sHeight: "138" },
        { sName: "vívoactive® 5", sPrice: "30,000", sDesc: "", sImage: require('@/assets/Catalogo/vívoactive® 5.jpg'), sCatId: "0", sWidth: "145", sHeight: "138" },
        { sName: "Forerunner® 55", sPrice: "20,000", sDesc: "", sImage: require('@/assets/Catalogo/Forerunner® 55.jpg'), sCatId: "0", sWidth: "229", sHeight: "138" },
        { sName: "oura ring 4", sPrice: "35,000", sDesc: "", sImage: require('@/assets/Catalogo/oura ring 4.jpg'), sCatId: "0", sWidth: "145", sHeight: "138" },
        { sName: "Whoop Strap 4.0 (Dispositivo)", sPrice: "23,900", sDesc: "", sImage: require('@/assets/Catalogo/Whoop Strap 4.0 (Dispositivo).jpg'), sCatId: "0", sWidth: "145", sHeight: "138" },
        { sName: "iPhone 15", sPrice: "70,000", sDesc: "", sImage: require('@/assets/Catalogo/iPhone 15.jpg'), sCatId: "0", sWidth: "145", sHeight: "138" },
        { sName: "iPhone 16", sPrice: "79,900", sDesc: "", sImage: require('@/assets/Catalogo/iPhone 16.jpg'), sCatId: "0", sWidth: "145", sHeight: "138" },
        { sName: "iPhone 16 Pro", sPrice: "99,900", sDesc: "", sImage: require('@/assets/Catalogo/iPhone 16 Pro.jpg'), sCatId: "0", sWidth: "300", sHeight: "138" },
        { sName: "Bolsa Carryall 35", sPrice: "15,000", sDesc: "", sImage: require('@/assets/Catalogo/Bolsa Carryall 35.jpg'), sCatId: "1", sWidth: "229", sHeight: "138" },
        { sName: "Bolsa Carryall 50", sPrice: "20,000", sDesc: "", sImage: require('@/assets/Catalogo/Bolsa Carryall 50.jpg'), sCatId: "1", sWidth: "145", sHeight: "138" },
        { sName: "CHILLER™ 30-Can Soft-Sided Portable Cooler", sPrice: "4,500", sDesc: "", sImage: require('@/assets/Catalogo/CHILLER™ 30-Can Soft-Sided Portable Cooler.jpg'), sCatId: "1", sWidth: "145", sHeight: "138" },
        { sName: "Classic Series 52-Quart Hard Cooler", sPrice: "5,000", sDesc: "", sImage: require('@/assets/Catalogo/Classic Series 52-Quart Hard Cooler.jpg'), sCatId: "1", sWidth: "145", sHeight: "138" },
        { sName: "Coleman 48-Quart Performance Cooler", sPrice: "5,000", sDesc: "", sImage: require('@/assets/Catalogo/Coleman 48-Quart Performance Cooler.jpg'), sCatId: "1", sWidth: "145", sHeight: "138" },
        { sName: "Coleman Now 24-Can Tote Cooler", sPrice: "5,000", sDesc: "", sImage: require('@/assets/Catalogo/Coleman Now 24-Can Tote Cooler.jpg'), sCatId: "1", sWidth: "229", sHeight: "138" },
        { sName: "Estuche de 1 L", sPrice: "4,000", sDesc: "", sImage: require('@/assets/Catalogo/Estuche de 1 L.jpg'), sCatId: "1", sWidth: "145", sHeight: "138" },
        { sName: "Hielera blanda tipo mochila M20", sPrice: "32,500", sDesc: "", sImage: require('@/assets/Catalogo/Hielera blanda tipo mochila M20.jpg'), sCatId: "1", sWidth: "145", sHeight: "138" },
        { sName: "Galon", sPrice: "13,000", sDesc: "", sImage: require('@/assets/Catalogo/Galon.jpg'), sCatId: "2", sWidth: "229", sHeight: "138" },
        { sName: "BOTELLA DE 64 OZ 1.9 L", sPrice: "6,500", sDesc: "", sImage: require('@/assets/Catalogo/BOTELLA DE 64 OZ 1.9 L.jpg'), sCatId: "2", sWidth: "220", sHeight: "138" },
        { sName: "Contigo® Huron 2.0 Stainless Steel Travel Mug with SNAPSEAL™ Lid, 16oz", sPrice: "1,500", sDesc: "", sImage: require('@/assets/Catalogo/Contigo® Huron 2.0 Stainless Steel Travel Mug with SNAPSEAL™ Lid, 16oz.jpg'), sCatId: "2", sWidth: "145", sHeight: "138" },
        // { sName: "NOX Mochila STREET", sPrice: "", sDesc: "", sImage: require('@/assets/Catalogo/NOX Mochila STREET negrogris claro.jpg'), sCatId: "3", sWidth: "300", sHeight: "138" },
        { sName: "Rodilleras para Pádel", sPrice: "1,500", sDesc: "", sImage: require('@/assets/Catalogo/Rodilleras para Pádel.jpg'), sCatId: "3", sWidth: "145", sHeight: "138" },
        { sName: "Pelotas para entrenamiento Pádel", sPrice: "1,500", sDesc: "", sImage: require('@/assets/Catalogo/Pelotas para entrenamiento Paddel.jpg'), sCatId: "3", sWidth: "145", sHeight: "138" },
        { sName: "OVAL METAL", sPrice: "18,000", sDesc: "", sImage: require('@/assets/Catalogo/OVAL METAL.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "ORIGINAL WAYFARER CLASSIC", sPrice: "18,000", sDesc: "", sImage: require('@/assets/Catalogo/ORIGINAL WAYFARER CLASSIC.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "NEW CLUBMASTER", sPrice: "18,000", sDesc: "", sImage: require('@/assets/Catalogo/NEW CLUBMASTER.jpg'), sCatId: "4", sWidth: "229", sHeight: "138" },
        { sName: "Breezer Bucket", sPrice: "4,500", sDesc: "", sImage: require('@/assets/Catalogo/Breezer Bucket.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "Tour Aussie", sPrice: "5,500", sDesc: "", sImage: require('@/assets/Catalogo/Tour Aussie.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "Premium Clover 1", sPrice: "3,600", sDesc: "", sImage: require('@/assets/Catalogo/Premium Clover 1.jpg'), sCatId: "4", sWidth: "229", sHeight: "138" },
        { sName: "Premium Clover 2", sPrice: "3,600", sDesc: "", sImage: require('@/assets/Catalogo/Premium Clover 2.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "Premium Clover 16", sPrice: "3,600", sDesc: "", sImage: require('@/assets/Catalogo/Premium Clover 16.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "Premium Clover 58", sPrice: "3,600", sDesc: "", sImage: require('@/assets/Catalogo/Premium Clover 58.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "Premium Clover 121", sPrice: "3,600", sDesc: "", sImage: require('@/assets/Catalogo/Premium Clover 121.jpg'), sCatId: "4", sWidth: "229", sHeight: "138" },
        { sName: "Premium Clover 127", sPrice: "3,600", sDesc: "", sImage: require('@/assets/Catalogo/Premium Clover 127.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "RB4420", sPrice: "15,100", sDesc: "", sImage: require('@/assets/Catalogo/RB4420.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "AVIATOR CLASSIC", sPrice: "18,000", sDesc: "", sImage: require('@/assets/Catalogo/AVIATOR CLASSIC.jpg'), sCatId: "4", sWidth: "229", sHeight: "138" },
        { sName: "Tour Breezer", sPrice: "3,500", sDesc: "", sImage: require('@/assets/Catalogo/Tour Breezer.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "Tour Elite", sPrice: "3,700", sDesc: "", sImage: require('@/assets/Catalogo/Tour Elite.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "Tour Performance TrueFit", sPrice: "3,700", sDesc: "", sImage: require('@/assets/Catalogo/Tour Performance TrueFit.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "Tour Rope", sPrice: "3,500", sDesc: "", sImage: require('@/assets/Catalogo/Tour Rope.jpg'), sCatId: "4", sWidth: "145", sHeight: "138" },
        { sName: "Black Diamond Spot 350 Headlamp", sPrice: "2,000", sDesc: "", sImage: require('@/assets/Catalogo/Black Diamond Spot 350 Headlamp.jpg'), sCatId: "5", sWidth: "145", sHeight: "138" },
        { sName: "Victorinox Swiss Army Classic SD Pocket Knife", sPrice: "2,000", sDesc: "", sImage: require('@/assets/Catalogo/Victorinox Swiss Army Classic SD Pocket Knife.jpg'), sCatId: "5", sWidth: "145", sHeight: "138" },
        { sName: "Brown Diamond Spot 350 Headlamp", sPrice: "5,000", sDesc: "", sImage: require('@/assets/Catalogo/Brown Diamond Spot 350 Headlamp.jpg'), sCatId: "5", sWidth: "229", sHeight: "138" },
        { sName: "Motorola T100 Talkabout Radio, 2 Pack Black", sPrice: "3,000", sDesc: "", sImage: require('@/assets/Catalogo/Motorola T100 Talkabout Radio, 2 Pack Black.jpg'), sCatId: "5", sWidth: "145", sHeight: "138" },
      ],
      bSelectedAll: false,
      dialogAddFounds: false,
      dialogSendPay: false,
      dialogSendPaySuppliers: false,
      dialogWithdrawal: false,
      dataAddFounds: {},
      dialogCreate: false,
      dialogPay: false,
      editableData: {},
      selectedCard: null,
      isForwardsActive: false,
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      bLoading: false,
      warranty: 0,
      stepper: false,
      e1: 1,
      blockedUsd: 0,
      blockedMXN: 0,
      headersAlerts: [
        { text: "Active alerts", value: "dAmount", align: "center" },
        { text: "Actions", value: "actions", align: "center" },
      ],
      balanceUsd: null,
      balanceMxn: null,
      transactions: [],
      exchangeRateToday: null,
      exchangeRateTodayFullNumbers: null,
      exchangeRateTodayReference: null,
      countdownDashboard: 59,
      intervalId: null,
      isLoadingSuppliers: false,
      suppliers: [],
      supplier: {},
      company: [],
      sAccountNumber: null,
      limit: null,
      isLoadingAlerts: false,
      isLoadingAlertsDelete: false,
      dialogAlertsCreate: false,
      targetPrice: null,
      isLoadingFounds: false,
      isLoadingAlertsCreate: false,
      isLoadingRate: false,
      currencyMap: {
        1: { name: "Dólares Estadounidenses", flag: require("@/assets/images/Flags_usa.svg") },
        USD: { name: "Dólares Estadounidenses", flag: require("@/assets/images/Flags_usa.svg") },
        MXN: { name: "Pesos Mexicanos", flag: require("@/assets/images/Flags_mex.svg") },
      },
      amounts: { USD: 0, MXN: 0 },
      isLoading: false,
      timer: null,
      limitWindowSpot: null,
      countdownRate: 60,
      reverseCalculator: false,
      rateForwardReference: null,
      withdrawal: null,
      baseCurrency: "",
      targetCurrency: "",
      loadingPayment: false,
      loadingConversion: false,
      loadingWithdrawal: false,
      paymentError: null,
      conversionError: null,
      withdrawalError: null,
      addFoundsCurrency: null,
      dialogToursList: false,
      dialogPreviewTour: false,
      loadingTours: false,
      loadingPreviewTour: false,
      availableTours: [],
      previewStepIndex: 0,
      previewTour: {
        id: null,
        title: "",
        steps: [],
      },
    };
  },
  created() {
  },
  methods: {
    removeMassPaymentRow(index) {
      if (this.massPaymentsRows.length > 1) {
        this.massPaymentsRows.splice(index, 1);
      }
    },
    resetMassPaymentDialog() {
      this.dialogSendPayMassive = false;
      this.massPaymentOriginCurrency = null;
      this.massPaymentsRows = [];
      this.massPaymentLoading = false;
      this.massPaymentStep = 1;
      this.massPaymentSuccess = false;
      this.massPaymentResultMessage = '';
    },
    onMassPaymentSupplierChange(row) {
      if (!row.supplier) {
        row.originAmount = 0;
        row.destAmount = 0;
        row.exchangeRateToday = null;
        row.exchangeRateReference = '';
        row.selectedTypeOfPayment = null;
        return;
      }
      row.originAmount = 0;
      row.destAmount = 0;
      row.exchangeRateToday = null;
      row.exchangeRateReference = '';
      row.selectedTypeOfPayment = null;
    },
    async calculatorAmountForMassRow(row, amount, reverse) {
      if (!row.exchangeRateReference || !this.massPaymentOriginCurrency) {
        return;
      }

      row.loadingRate = true;
      const payload = {
        amount,
        rate: row.exchangeRateReference,
        reverse,
      };

      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/dashboard/calculatorAmount`, payload, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
          },
        });
        const result = parseFloat(response.data.data.result);
        const rounded = this.roundHalfEven(result, 2).toFixed(2);
        if (reverse) {
          row.originAmount = rounded;
        } else {
          row.destAmount = rounded;
        }
      } catch (error) {
        this.mixError(error.response.data.message, error.response.status);
      } finally {
        row.loadingRate = false;
      }
    },
    async getRateForMassRow(row) {
      if (!this.massPaymentOriginCurrency || !row.supplier) {
        return;
      }

      row.loadingRate = true;
      row.exchangeRateToday = null;
      row.exchangeRateReference = '';
      row.originAmount = 0;
      row.destAmount = 0;


      const payload = {
        currency: this.massPaymentOriginCurrency,
        desCurrency: row.supplier.sAccountCurrency,
      };

      if (payload.currency === payload.desCurrency) {
        row.loadingRate = false;
        return;
      }
      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/dashboard/getExchangeRate`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        });
        row.exchangeRateToday = response.data.exchangeRateToday;
        row.exchangeRateReference = response.data.exchangeRateTodayReference;
        this.mixSuccess(response.data.message);
      } catch (error) {
        this.mixError(error.response.data.message, error.response.status);
      } finally {
        row.loadingRate = false;
      }
    },
    addMassPaymentRow() {
      const limit = 10;
      if (this.massPaymentsRows.length < limit) {
        this.massPaymentsRows.push(this.createMassPaymentRow());
      } else {
        this.mixError(`No puedes agregar más de ${limit} filas.`, 400);
      }
    },
    selectMassPaymentCurrencyUSD() {
      this.massPaymentOriginCurrency = 'USD';
      this.massPaymentsRows = [];
      this.massPaymentsRows.push(this.createMassPaymentRow());
    },
    selectMassPaymentCurrencyMXN() {
      this.massPaymentOriginCurrency = 'MXN';
      this.massPaymentsRows = [];
      this.massPaymentsRows.push(this.createMassPaymentRow());
    },
    createMassPaymentRow() {
      return {
        id: `row-${Date.now()}-${Math.floor(Math.random() * 10000)}`,
        supplier: null,
        originAmount: 0,
        destAmount: 0,
        exchangeRateToday: null,
        exchangeRateReference: '',
        selectedTypeOfPayment: null,
        comment: '',
        loadingRate: false,
      };
    },
    continueToPaymentDetail() {
      if (!this.hasValidExchangeRateForPayment) {
        this.mixError("Tipo de cambio inválido. Actualiza e inténtalo de nuevo.", 400);
        return;
      }
      this.e1 = 4;
      this.stopRateTimer();
      this.comment = "";
    },
    continueToOtpStep() {
      if (!this.hasValidExchangeRateForPayment) {
        this.mixError("Tipo de cambio inválido. Actualiza e inténtalo de nuevo.", 400);
        return;
      }
      this.e1 = 5;
      this.otp = "";
      this.sendVerification();
    },
    continueToOtpStepFromMassPayment() {
      this.e1 = 4;
      this.otp = "";
      this.sendVerification();
    },
    confirmPaymentWithValidation() {
      if (!this.hasValidExchangeRateForPayment) {
        this.mixError("Tipo de cambio inválido. Actualiza e inténtalo de nuevo.", 400);
        return;
      }
      this.e1 = 6;
      this.sendPayment();
    },
    async sendMassPayment() {
      this.massPaymentLoading = true;
      this.massPaymentSuccess = false;
      this.massPaymentResultMessage = '';

      const payload = {
        payments: this.massPaymentsRows.map((row) => ({
          sPaymentRecipientId: row.supplier.sPaymentRecipientId,
          dOriginAmount: parseFloat(row.originAmount),
          dDestAmount: parseFloat(row.destAmount),
          dOriginCurrency: this.massPaymentOriginCurrency,
          dDestCurrency: row.supplier.sAccountCurrency,
          comment: row.comment,
          sExchangeRateReference: row.exchangeRateReference,
          reverse: row.supplier.sAccountCurrency !== this.massPaymentOriginCurrency,
          selectedTypeOfPayment: "Spot",
          beneficiaryName: row.supplier.sName,
        })),
      };

      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/payments/createMassPayment`, payload, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
          },
        });
        this.massPaymentSuccess = true;
        this.massPaymentResultMessage = response.data.message || 'Todos los pagos se procesaron correctamente.';
        this.massPaymentFailedCount = response.data.failedCount || 0;
        this.massPaymentResults = response.data.results || [];
        this.mixSuccess(this.massPaymentResultMessage);
      } catch (error) {
        this.massPaymentSuccess = false;
        this.massPaymentResultMessage = error.response?.data?.message || 'Error al procesar los pagos.';
        this.massPaymentResults = error.response?.data?.results || [];
        this.mixError(this.massPaymentResultMessage, error.response?.status);
      } finally {
        this.massPaymentLoading = false;
      }
    },
    continueToConvertDetail() {
      if (!this.hasValidExchangeRateForConversion) {
        this.mixError("Tipo de cambio inválido. Actualiza e inténtalo de nuevo.", 400);
        return;
      }
      this.e1 = 3;
      this.stopRateTimer();
    },
    continueToConvertOtpStep() {
      if (!this.hasValidExchangeRateForConversion) {
        this.mixError("Tipo de cambio inválido. Actualiza e inténtalo de nuevo.", 400);
        return;
      }
      this.e1 = 4;
      this.sendVerification();
      this.otp = "";
    },
    confirmConvertWithValidation() {
      if (!this.hasValidExchangeRateForConversion) {
        this.mixError("Tipo de cambio inválido. Actualiza e inténtalo de nuevo.", 400);
        return;
      }
      this.e1 = 5;
      this.sendConvert();
    },
    swapCurrencies() {
      [this.baseCurrency, this.targetCurrency] = [this.targetCurrency, this.baseCurrency];
      this.amounts = { USD: 0, MXN: 0 };
      if (this.selectedCard === 3) {
        this.dDateForward = null;
      }
      this.getRate(this.baseCurrency, this.targetCurrency);
    },
    changeTab(tab) {
      this.selectedTab = tab;
      this.$emit('tab-changed', tab);
    },
    openDialogProduct(item) {
      this.dialogProduct = true;
      this.selectedItem = item;
    },
    async getRate(originCurrency, destCurrency) {
      this.isLoadingRate = true;
      this.exchangeRateToday = null;
      this.exchangeRateTodayReference = null;
      this.amounts = { USD: 0, MXN: 0 };

      const payload = {
        currency: originCurrency,
        desCurrency: destCurrency,
      };

      if (originCurrency != destCurrency) {
        DB.post(`${URI}/api/v1/${this.selectLanguage}/dashboard/getExchangeRate`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
        .then((response) => {
          this.exchangeRateToday = response.data.exchangeRateToday;
          this.exchangeRateTodayReference = response.data.exchangeRateTodayReference;
          if (this.selectedCard != 3) {
            this.startRateTimer(originCurrency, destCurrency);
          }
          this.mixSuccess(response.data.message);
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.isLoadingRate = false;
        });
      }
    },
    roundHalfEven(num, decimals = 2) {
      const factor = Math.pow(10, decimals);
      const temp = num * factor;
      const floor = Math.floor(temp);
      const diff = temp - floor;

      if (diff === 0.5) {
        return (floor % 2 === 0 ? floor : floor + 1) / factor;
      }

      return Math.round(temp) / factor;
    },
    async calculatorAmount(amount, reverse, currency, desCurrency) {
      this.isLoadingRate = true;
      let rate = this.exchangeRateTodayReference;
      this.reverseCalculator = reverse;

      const payload = {
        amount: amount,
        rate: rate,
        reverse: this.reverseCalculator,
        currency: currency,
        desCurrency: desCurrency,
      };

      try {
        DB.post(`${URI}/api/v1/${this.selectLanguage}/dashboard/calculatorAmount`, payload, {
          headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
        })
        .then((response) => {
          const result = parseFloat(response.data.data.result);
          this.amounts[this.reverseCalculator ? currency : desCurrency] = this.roundHalfEven(result, 2).toFixed(2);
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.isLoadingRate = false;
        });
      } catch (error) {
        this.mixError(error.response.data.message, error.response.status);
      }
    },
    async getForwardRate(amount, reverse) {
      this.isLoadingRate = true;

      const payload = {
        dDateForward: this.dDateForward,
        dAmount: amount,
        referenceExchangeRate: this.exchangeRateTodayReference,
        reverse: reverse
      };
      try {
        DB.post(`${URI}/api/v1/${this.selectLanguage}/transactions/forwardRate`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
        .then((response) => {
          this.exchangeRateToday = response.data.forwardRate.rate;
          this.rateForwardReference = response.data.forwardRate.uuid;
          if (amount > 0) {
            this.warranty = response.data.forwardRate.initial_percentage_amount;
            if (reverse) {
              this.amounts[this.baseCurrency] = response.data.forwardRate.result;
            } else {
              this.amounts[this.targetCurrency] = response.data.forwardRate.result;
            }
            this.reverseCalculator = reverse;
          }
          this.mixSuccess(response.data.message);
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.isLoadingRate = false;
        });
      } catch (error) {
        this.mixError(
          error.response?.data?.message || "Error desconocido",
          error.response?.status || 500
        );
        throw error;
      }
    },
    startCountdownDashboard() {
      if (this.intervalId) return; 

      this.countdownDashboard = 60;

      this.intervalId = setInterval(() => {
        if (this.countdownDashboard > 0) {
          this.countdownDashboard--;
        } else {
          this.stopDashboardRateTimer();
          this.getDashboard("from countdown");
        }
      }, 1000);
    },
    stopDashboardRateTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    startRateTimer(originCurrency, destCurrency) {
      if (this.timer) return;

      this.countdownRate = 60;

      this.timer = setInterval(() => {
        if (this.countdownRate > 0) {
          this.countdownRate--;
        } else {
          this.stopRateTimer(this.timer);
          this.getRate(originCurrency, destCurrency);
        }
      }, 1000);
    },
    stopRateTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    sendVerification() {
      try {
        DB.get(`${URI}/api/v1/${this.selectLanguage}/authenticator/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            if (!response.data.success) {
              this.mixError(response.data.message, response.status);
            }
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
      } catch (error) {
        this.mixError(error.response.data.message, error.response.status);
      }
    },
    async validateOtp() {
      try {
        const payload = {
          sCode: this.otp,
        };

        const response = await DB.post(
          `${URI}/api/v1/${this.selectLanguage}/authenticator/verify`,
          payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          }
        );

        return response.data.success;
      } catch (error) {
        return false;
      }
    },
    async sendConvert() {
      this.loadingConversion = true;
      this.conversionError = null;
      if (!this.hasValidExchangeRateForConversion) {
        this.loadingConversion = false;
        this.conversionError = true;
        this.mixError("Tipo de cambio inválido. Actualiza e inténtalo de nuevo.", 400);
        return;
      }
      const isOtpValid = await this.validateOtp();

      if (!isOtpValid) {
        this.loadingConversion = false;
        this.mixError("Invalid code", 400);
        return;
      }
      let sTransactionType = "";
      if (this.selectedCard === 2) {
        sTransactionType = "e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a";
      } else if (this.selectedCard === 3) {
        sTransactionType = "b80e8dc6-4138-449e-8903-968efb8437b3";
      } else if (this.selectedCard === 4) {
        sTransactionType = "484a23d2-7dc1-4fd0-a1b0-3402d066c2cf";
      }

      const payload = {
        sTransactionType: sTransactionType,
        dOriginCurrency: this.baseCurrency,
        dDestCurrency: this.targetCurrency,
        dOriginAmount: parseFloat(this.amounts[this.baseCurrency]),
        dDestAmount: parseFloat(this.amounts[this.targetCurrency]),
        dExchangeRate: this.exchangeRateToday,
        referenceExchangeRate: this.exchangeRateTodayReference,
        bExternal: false,
        dForwardTransactionDate: this.dDateForward,
        reverse: this.reverseCalculator,
        dPercentageAmount: this.warranty,
        rateForwardReference: this.rateForwardReference,
      };
      try {
        const response = await DB.post(
          `${URI}/api/v1/${this.selectLanguage}/transactions/`,
          payload,
          { headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""}}
        );
        this.mixSuccess(response.data.message);
        this.conversion = response.data.transaction;
        this.conversionError = false;
      } catch (error) {
        this.conversionError = true;
        this.mixError(error.response.data.message, error.response.status);
      } finally {
        this.loadingConversion = false;
      }
    },
    async sendPayment() {
      this.loadingPayment = true;
      this.paymentError = null;
      if (!this.hasValidExchangeRateForPayment) {
        this.loadingPayment = false;
        this.paymentError = true;
        this.mixError("Tipo de cambio inválido. Actualiza e inténtalo de nuevo.", 400);
        return;
      }
      const isOtpValid = await this.validateOtp();

      if (!isOtpValid) {
        this.loadingPayment = false;
        this.mixError("Invalid code", 400);
        return;
      }
      const payload = {
        dOriginAmount: this.amounts[this.selectedCurrency],
        dDestAmount: this.amounts[this.supplier.sAccountCurrency],
        dOriginCurrency: this.selectedCurrency,
        dDestCurrency: this.supplier.sAccountCurrency,
        comment: this.comment,
        sPaymentRecipientId: this.supplier.sPaymentRecipientId,
        sExchangeRateReference: this.exchangeRateTodayReference,
        reverse: this.reverseCalculator,
        selectedTypeOfPayment: this.selectedTypeOfPayment,
      };

      try {
        const response = await DB.post(
          `${URI}/api/v1/${this.selectLanguage}/payments/sendPayment`,
          payload,
          { headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""}}
        );
        this.mixSuccess(response.data.message);
        this.payment = response.data.payment;
        this.paymentError = false;
      } catch (error) {
        this.paymentError = true;
        this.mixError(error.response.data.message, error.response.status);
      } finally {
        this.loadingPayment = false;
      }
    },
    async sendWithdrawal() {
      this.loadingWithdrawal = true;
      this.withdrawalError = null;
      const isOtpValid = await this.validateOtp();

      if (!isOtpValid) {
        this.loadingWithdrawal = false;
        this.mixError("Invalid code", 400);
        return;
      }
      const payload = {
        dOriginAmount: this.amounts[this.selectedCurrency],
        dDestAmount: this.amounts[this.company.sAccountCurrency],
        dOriginCurrency: this.selectedCurrency,
        dDestCurrency: this.company.sAccountCurrency,
        comment: this.comment,
        sPaymentRecipientId: this.company.sPaymentRecipientId,
        sExchangeRateReference: this.exchangeRateTodayReference,
        reverse: this.reverseCalculator,
        selectedTypeOfPayment: this.selectedTypeOfPayment,
      };
      try {
        const response = await DB.post(
          `${URI}/api/v1/${this.selectLanguage}/payments/sendWithdrawal`,
          payload,
          { headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""}}
        );
        this.mixSuccess(response.data.message);
        this.withdrawal = response.data.payment;
        this.withdrawalError = false;
      }
      catch (error) {
        this.withdrawalError = true;
        this.mixError(error.response.data.message, error.response.status);
      } finally {
        this.loadingWithdrawal = false;
      }
    },
    async getDashboard() {
      try {
        this.loading = true;

        const response = await DB.get(`${URI}/api/v1/${this.selectLanguage}/dashboard`, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
          },
        });

        const data = response.data;
        const hasWalletsData = Boolean(
          data?.balances?.balanceUsd &&
          data?.balances?.balanceMxn &&
          data?.balances?.blocked &&
          data?.balances?.blockedMXN
        );

        if (!hasWalletsData) {
          this.stopDashboardRateTimer();
          return;
        }

        this.items = data;
        this.amounts = { USD: 0, MXN: 0 };
        this.balanceUsd = data.balances.balanceUsd.balance;
        this.balanceMxn = data.balances.balanceMxn.balance;
        this.blockedUsd = data.balances.blocked.balance;
        this.blockedMXN = data.balances.blockedMXN.balance;
        this.exchangeRateTodayReference = data.exchangeRateTodayReference;

        // Determinar operación para definir base y destino
        this.baseCurrency = data.operationType === "Venta" ? 'USD' : 'MXN';
        this.targetCurrency = data.operationType === "Venta" ? 'MXN' : 'USD';

        this.loading = false;
        this.startCountdownDashboard();

      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
          this.loading = false;
        }

        this.stopDashboardRateTimer();
      }
    },
    formatMoney(value) {
      let multiplied = value * 100;
      let truncated = Math.trunc(multiplied);
      let formattedNumber = truncated / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate(date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    getSuppliers() {
      this.isLoadingSuppliers = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/payment-recipient/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.isLoadingSuppliers = false;
          this.suppliers = response.data.paymentRecipients;
          this.suppliers.map((item) => {
            item.sNameAC = item.sName + " - *******" + (item.sAccountNumber ? item.sAccountNumber.slice(-4) : item.accountNumber.slice(-4)) + " - (" + item.sAccountCurrency + ")";
          });
          console.log(this.suppliers)
        })
        .catch((error) => {
          this.isLoadingSuppliers = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    getCompany() {
      this.isLoadingSuppliers = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/payment-recipient/company`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.isLoadingSuppliers = false;
          this.company = response.data.paymentRecipients;
        })
        .catch((error) => {
          this.isLoadingSuppliers = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    openModalAddFounds(currency) {
      this.dialogAddFounds = true;
      this.addFoundsCurrency = currency;
      this.isLoadingFounds = true;
      this.dataAddFounds = {};
      const payload = {
        currency: currency,
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/exchange-rate/addFounds`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.dataAddFounds = response.data.account;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.isLoadingFounds = false;
        });
    },
    openModalAlerts() {
        this.dialogAlerts = true;
        this.isLoadingAlerts = true;
        //Get alerts
        DB.get(`${URI}/api/v1/${this.selectLanguage}/alerts/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.alerts = response.data.alerts;
          this.isLoadingAlerts = false;
        })
        .catch((error) => {
          this.isLoadingAlerts = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    async deleteAlert(item) {
      this.isLoadingAlertsDelete = true;
      const payload = {
        sAlertId: item.sAlertId
      };
      const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/alerts/deleteAlert`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      });

      if (response.data.success) {
        this.mixSuccess(response.data.message);
        this.alerts = this.alerts.filter(alert => alert.sAlertId !== item.sAlertId);
      } else {
        this.mixError(response.data.message, 400);
      }
      this.isLoadingAlertsDelete = false;
    },
    openDialogAlertsCreate() {
      this.dialogAlertsCreate = true;
    },
    createAlert() {
      this.isLoadingAlertsCreate = true;
      const payload = {
        dAmount: this.targetPrice,
        dAmountSpot: this.items.exchangeRateToday,
        sType: "8e574e88-2670-469e-b96e-7091082d82b9"
      };
      DB.post(`${URI}/api/v1/${this.selectLanguage}/alerts`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        if (response.data.success) {
          this.mixSuccess(response.data.message);
          this.isLoadingAlertsCreate = false;
          this.dialogAlertsCreate = false;
          this.targetPrice = null;
          this.openModalAlerts();
      } else {
          this.mixError(response.data.message, 400);
        }
        this.isLoadingAlertsCreate = false;
      })
      .catch((error) => {
        this.isLoadingAlertsCreate = false;
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    onlyWeekdays(date) {
      const day = new Date(date).getDay();
      return day !== 5 && day !== 6;
    },
    checkTime() {
      this.currentTime = this.currentDate.format("MMMM DD, YYYY, HH:mm:ss [GMT]Z");
      this.currentTimeCdmx = this.currentDateCdmx.format(
        "MMMM DD, YYYY, HH:mm:ss [GMT-6]"
      );
      const currentHourCdmx = this.currentDateCdmx.hour();
      const currentDayCdmx = this.currentDateCdmx.day();
      if (currentDayCdmx === 6 || currentDayCdmx === 0) {
        this.isDisabledForward = true;
      } else if (currentHourCdmx >= 9 && currentHourCdmx < 14) {
        this.isDisabledForward = false;
      } else {
        this.isDisabledForward = true;
      }
      if (currentDayCdmx === 6 || currentDayCdmx === 0) {
        this.isDisabledWindow = true;
      }
    },
    shouldShowItem(idx) {
      return Math.floor(this.items.fresherCoins / 2500) === idx - 1;
    },
    computedMarginLeft() {
      const fresherCoins = this.items.fresherCoins;

      const remainder = fresherCoins % 2500;
      const normalizedValue = remainder / 2499;

      const minMargin = 1.04;
      const maxMargin = 78.96;

      let computedMargin = minMargin + (maxMargin - minMargin) * normalizedValue;

      if (remainder === 0) computedMargin = -2.4;

      return `${computedMargin}px`;
    },
    pendingFresherCoins() {
      const fresherCoins = this.items.pendingFresherCoins;

      const remainder = fresherCoins % 2500;
      const normalizedValue = remainder / 2499;

      const minMargin = 1.04;
      const maxMargin = 78.96;

      let computedMargin = minMargin + (maxMargin - minMargin) * normalizedValue;

      if (remainder === 0) computedMargin = -2.4;

      return `${computedMargin}px`;
    },
    openToursDialog() {
      this.dialogToursList = true;
      this.loadingTours = true;
      this.availableTours = [];

      DB.get(`${URI}/api/v1/en/tours/listTours?type=update`, {
        headers: {
          Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
        },
      })
        .then((response) => {
          this.availableTours = (response.data.tours || [])
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        })
        .catch((error) => {
          this.mixError(
            error.response?.data?.message || "Error al cargar actualizaciones",
            error.response?.status || 500
          );
        })
        .finally(() => {
          this.loadingTours = false;
        });
    },
    closeToursDialog() {
      this.dialogToursList = false;
    },
    viewTourDetail(tour) {
      this.dialogToursList = false;
      this.dialogPreviewTour = true;
      this.loadingPreviewTour = true;
      this.previewStepIndex = 0;
      this.previewTour = { id: null, title: "", steps: [] };

      // Obtener detalle del tour
      DB.get(`${URI}/api/v1/en/tours/check/${tour.id}`, {
        headers: {
          Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
        },
      })
        .then((response) => {
          const tourDetail = response.data.tour;
          this.previewTour = {
            id: tourDetail.id,
            title: tourDetail.title || "",
            steps: (tourDetail.steps || [])
              .sort((a, b) => a.step_order - b.step_order)
              .map((step) => ({
                ...step,
                image_signed_url: step.image_signed_url || null,
              })),
          };
        })
        .catch((error) => {
          this.mixError(
            error.response?.data?.message || "Error al cargar tour",
            error.response?.status || 500
          );
          this.closePreviewTour();
        })
        .finally(() => {
          this.loadingPreviewTour = false;
        });
    },
    closePreviewTour() {
      this.dialogPreviewTour = false;
      this.previewStepIndex = 0;
      this.previewTour = { id: null, title: "", steps: [] };
      // Marcar como visto
      if (this.previewTour.id) {
        this.markTourAsSeen(this.previewTour.id);
      }
    },

    markTourAsSeen(tourId) {
      DB.post(
        `${URI}/api/v1/en/tours/seen`,
        { tour_id: tourId },
        { headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
          } 
        }
      )
        .then(() => {
          // Actualizar lista sin recargar
          const tour = this.availableTours.find((t) => t.id === tourId);
          if (tour) tour.seen = true;
        })
        .catch((error) => {
          console.error("Error marking tour as seen:", error);
        });
    },

    goNextPreviewStep() {
      if (this.isLastPreviewStep) {
        this.closePreviewTour();
        return;
      }
      this.previewStepIndex += 1;
    },

    goPreviousPreviewStep() {
      if (this.isFirstPreviewStep) {
        return;
      }
      this.previewStepIndex -= 1;
    },

    truncateText(text, max = 120) {
      if (!text) return "";
      const value = String(text);
      return value.length > max ? `${value.slice(0, max)}...` : value;
    },
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getDashboard();
    this.paymentDay = moment().format("YYYY-MM-DD");
    this.today = moment().add(1, "day").format("YYYY-MM-DD");
    this.limitWindowSpot = moment().add(7, "day").format("MMMM DD, YYYY");
    this.limit = moment(this.today).add(1, "year").format("YYYY-MM-DD");
    this.checkTime();
    this.getCompany();
  },
  beforeDestroy() {
    this.stopDashboardRateTimer();
    this.stopRateTimer();
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    currentPreviewStep() {
      return this.previewTour.steps?.[this.previewStepIndex] || null;
    },
    isLastPreviewStep() {
      return !this.previewTour.steps?.length || this.previewStepIndex === this.previewTour.steps.length - 1;
    },
    isFirstPreviewStep() {
      return !this.previewTour.steps?.length || this.previewStepIndex === 0;
    },
    unreadToursCount() {
      return this.availableTours.filter((t) => !t.seen).length;
    },
    hasValidExchangeRateForPayment: function () {
      if (this.selectedCurrency === this.supplier?.sAccountCurrency) {
        return true;
      }
      return Boolean(
        this.exchangeRateTodayReference &&
        Number(this.exchangeRateToday) > 0
      );
    },
    hasValidExchangeRateForConversion: function () {
      if (this.baseCurrency === this.targetCurrency) {
        return true;
      }
      if (this.selectedCard === 3) {
        return Boolean(
          this.rateForwardReference &&
          Number(this.exchangeRateToday) > 0
        );
      }
      return Boolean(
        this.exchangeRateTodayReference &&
        Number(this.exchangeRateToday) > 0
      );
    },
    massPaymentTotalOrigin() {
      return this.massPaymentsRows.reduce((sum, row) => {
        const value = parseFloat(row.originAmount || 0);
        return sum + (Number.isFinite(value) ? value : 0);
      }, 0);
    },
    canSubmitMassPayment() {
      if (!this.massPaymentOriginCurrency || this.massPaymentsRows.length === 0) {
        return false;
      }
      return this.massPaymentsRows.every((row) => {
        const hasSupplier = !!row.supplier;
        const validAmounts = parseFloat(row.originAmount || 0) > 0 && parseFloat(row.destAmount || 0) > 0;
        const requiresExchange = row.supplier && row.supplier.sAccountCurrency !== this.massPaymentOriginCurrency;
        const hasRate = !requiresExchange || (!!row.exchangeRateReference && !!row.exchangeRateToday);
        const hasConcept = !!row.comment;
        return hasSupplier && validAmounts && hasRate && hasConcept;
      });
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
    },
    clockTime(currentTime) {
      var ms = moment(this.lastUpdateclockTime, "HH:mm:ss").diff(
        moment(currentTime, "HH:mm:ss")
      );
      var d = moment.duration(ms);
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
    color: yellow !important;
    background-color: yellow !important;
  }

  .active-section .v-list-item__title {
    background-color: yellow !important;
  } */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #f0be43 !important;
  height: 3px;
  color: #f0be43 !important;
  border-radius: 100px;
}

.card-main {
  position: relative;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #f0be43;
}

 /* .btn-custom-alerts {
  color: black;
  font-size: 10px;
  background-color: #FFF;
} */

.custom-dialog-alerts {
  background-color: red; /* Cambia al color deseado */
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #f0be43;
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #0075b8;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}
.scroll::-webkit-scrollbar {
  display: none;  /* Oculta la barra de desplazamiento en navegadores basados en WebKit */
}
.toggle-container {
  display: flex;
  border: 4px solid #3578ba;
  border-radius: 100px;
  overflow: hidden;
  background-color: #3578ba;
}

.toggle-button {
  flex: 1;
  padding: 10px 20px;
  border: none;
  background-color: transparent;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
}

.toggle-button.active {
  background-color: #ffffff;
  color: #3578ba;
  border-radius: 20px;
}

.toggle-button:not(.active) {
  background-color: #3578ba;
  color: white;
}

.v-btn--outlined {
  border: 2px solid currentColor;
}
.v-tabs-slider {
  background: #193D6E !important;
  height: 3px;
  color: #193D6E !important;
  border-radius: 100px;
}

.custom-text {
  color: #193d6e;
  position: absolute;
  margin-top: -77px;
  z-index: 2;
}

.info-card {
  background-color: white;
  border-radius: 20px;
  padding: 16px;
}

.info-block {
  background-color: #F2F2F2;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.label {
  color: #737583;
  font-family: "montserrat-bold";
  font-size: 14px;
  margin-bottom: 2px;
  padding: 5px;
  width: fit-content;
}

.value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 16px;
  padding: 5px;
  margin-bottom: 5px;
  width: fit-content;
  text-align: right;
}
.text-red {
  color: red;
}
.tour-item {
  transition: all 0.3s ease;
}
.tour-item:hover {
  background-color: #f5f5f5 !important;
  transform: translateY(-2px);
}
.preview-image-wrap {
  position: relative;
  background: #f5f5f5;
}
.preview-image {
  width: 100%;
}
.preview-close-btn {
  position: absolute !important;
  top: 14px;
  right: 14px;
  background: #ffffff !important;
}
.preview-title {
  font-family: 'montserrat-bold';
  font-size: 46px;
  color: #1a2238;
}
.preview-description {
  margin-top: 14px;
  font-family: 'montserrat-medium';
  font-size: 22px;
  line-height: 1.5;
  color: #4f5b72;
}
.preview-progress {
  display: grid;
  align-items: center;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}
.preview-progress-segment {
  height: 8px;
  border-radius: 8px;
  background: #d9dde5;
  transition: all 0.3s ease;
}
.preview-progress-segment.active {
  background: #8ec5ff;
}
.preview-progress-segment.current {
  height: 14px;
  background: #2f66ff;
}
.preview-counter {
  font-family: 'montserrat-bold';
  font-size: 28px;
  color: #6f7788;
}
.gap-3 {
  gap: 12px;
}
</style>
